import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'app/service/auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../loginone/login.service';
import { UserLogin } from 'app/shared/models/user-login.model';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import { ValidateService } from 'app/shared/validate.service';
import { GlobalService } from 'app/shared/global.service';
import { DatePipe } from '@angular/common';
import { MiscService } from 'app/shared/misc.service';
// import { SetRights } from 'app/shared/set-rights';
import { PickDateAdapter, PICK_FORMATS } from "app/shared/format-datepicker";
import { DateAdapter, MAT_DATE_FORMATS } from "@angular/material/core";
import { BookingService } from '../booking/booking.service';
import { CommonService } from 'app/shared/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentGatewayService } from './payment-gateway.service';
import { BookingLoginService } from './booking-login.service';

declare var Razorpay: any;

@Component({
  selector: 'app-booking-login',
  templateUrl: './booking-login.component.html',
  styleUrls: ['./booking-login.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: PickDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS }
  ],
})
export class BookingLoginComponent implements OnInit {

  filters: string = '';
  messages = {};
  public currentDate = new Date();
  datePipe = new DatePipe("en-US");
  Today = '';
  // View: boolean = false;

  items: [];
  AdmissionDuration: number = 0;
  validations: string[] = [];
  View: boolean = false;
  isregister: boolean = false;
  checkOut = '';
  hideRow = false;
  ngForm: FormGroup;
  emailPattern: string = "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$";
  isRegistration = false;
  loginForm: any;
  isInProgress = false;
  page = 1;
  Historypage = 1;
  LoginOnlineUserRegistrationID = 0;
  GuestName = "";
  headers: string[] = [];
  selectedAliesName: string;
  selectedRate = 0;
  isMainScreen = true;
  hide = true;
  //isPaymentHistory = false;
  Prefix = [];
  IsOTPSent = false;
  IsEmailVerified = false; // used to check if OTP is matched for email verification from register with us. true if matched
  OTP: string = ""; //4 digit otp for email verification
  GuestOTP: string = "";
  LanguageType = [];
  otp: string[] = new Array(4).fill('');
  EnteredOTP = '';
  ResendCount = 0;
  isResendDisabled: boolean = false;
  isResendUsed: boolean = false; // Track if resend has been used
  countdown: number = 60;
  timer: any;
  errorMessage: string = '';
  PaymentServiceProvider = 'Razorpay Payment Gateway';
  States = [];
  City = [];
  District = [];
  CancellationReasonList = [];
  configurationDetaild = [];
  tariffData: any[] = [];
  roomCategories: any[] = [];
  specialTreatments: any[] = [];
  otherCharges: any[] = [];
  tariffEffectiveFrom: any;
  defaultDOB = '';
  slideConfigBed = {
    slidesToShow: 2,
    slidesToScroll: 2,
    dots: true,
    infinite: false,
    responsive: []
  };
  AdmissionDurationRange = [];
  minDuration = 0;

  OnlineUserRegistration = {
    'OnlineUserRegistrationID': 0,
    'LoginMethod': 'password',
    'FirstName': '',
    'MiddleName': '',
    'LastName': '',
    'City': '',
    'District': '',
    'State': '',
    'Country': '',
    'MigratedToRegistrationID': 0,
    'MobileNo': '',
    'WhatsAppNo': '',
    'UserID': '',
    'Email': '',
    'Password': '',
    'ConfirmPassword': '',
    'UserName': '',
    'LoginPassword': '',
    'Type': '',
    'RememberMe': false
  };

  itemToEditImage = {
    'PatientID': 0,
    'OnlinePatientRegistrationID': 0,
    'Link': '',
    'Date': '',
    'ClientID': 0,
    'LocationID': 0,
    'url': '',
    'FileExtension': '',
    'AtachDoc': [{
      "FileUploadID": 0,
      'ClientID': 0,
      'LocationID': 0,
      'PatientID': 0,
      'OnlinePatientRegistrationID': 0,
      'FileName': '',
      'UploadedName': '',
      'Remark': '',
      'AddedBy': "",
      'Add': true,
      'FileIndex': 0,
      'IsFileSelected': true,
      'Date': this.datePipe.transform(this.globals.CurrentDateTime, 'dd-MM-yyyy'),
      'FileUploadServerType': '',
      'LocalFolderPath': '',
      'ClientDetails': '',
    }],
  };

  itemToEditPageHit = {
    'PageUrl': '',
    'HitDate': new Date(),
    'HitCount': 1,
    'UserIP': '',
  };

  constructor(
    private router: Router,
    private loginService: LoginService,
    private toasterService: ToastrService,
    public translate: TranslateService,
    public validateService: ValidateService,
    public globals: GlobalService,
    public cdr: ChangeDetectorRef,
    private paymentGatewayService: PaymentGatewayService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private miscService: MiscService,
    public bookingService: BookingService,
    public bookingloginService: BookingLoginService,
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
  ) { }

  trackByFn(index: number, item: any): any {
    return index; // Or return a unique identifier of the item
  }

  GetComponentID() {
    this.globals.CurrentDateTime = new Date();
    this.Today = this.datePipe.transform(this.globals.CurrentDateTime, 'yyyy-MM-dd');
    this.miscService.getMiscellaneous('Prefix').subscribe(data => {
      this.Prefix = data as string[];
    });
    this.miscService.getMiscellaneous('AdmissionDuration').subscribe(data => {
      this.AdmissionDurationRange = (data as any[]).sort((a, b) => Number(a.ExtraDescription) - Number(b.ExtraDescription));
      this.minDuration = Math.min(
        ...this.AdmissionDurationRange.map(x => Number(x.Description))
      );
      this.AdmissionDuration = this.minDuration;
    });
    this.miscService.getMiscellaneous('LanguageType').subscribe(data => {
      this.LanguageType = data as string[];
    });
    this.miscService.getMiscellaneous('CancellationReason').subscribe(data => {
      this.CancellationReasonList = data as string[];
    });
    this.GetTariff();
    //this.GetRoomCategories();
    this.GetCountryandNationality();
    this.getStateList();
  }

  AllRegulations = [];
  ProtocolRegulation = [];
  isChecked: boolean = false;
  // Get All regulation from mstregulation
  GetAllRegulations() {
    this.bookingService.GetAllRegulations().subscribe((data) => {
      this.AllRegulations = data;
      this.ProtocolRegulation = this.AllRegulations.filter((x) => x['RegulationType'] == 'Protocol' && x['RegulationModule'] == 'Online Booking');
      // for (let i = 0; i < this.ProtocolRegulation.length; i++) {
      //   this.ProtocolRegulation[i]["RegulationDescriptionEnglish"] = this.ProtocolRegulation[i]["RegulationDescriptionEnglish"].replace(/(\r\n|\n|\r)/g, '<br>');
      //   console.log(this.ProtocolRegulation[i]["RegulationDescriptionEnglish"]);
      // }
    });
  }

  GetRoomCategories() {
    this.bookingloginService.GetRoomCategories().subscribe(
      (response: any) => {
        this.roomCategories = response;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  GetTariff() {

    this.bookingloginService.GetTariff().subscribe(
      (data: any[]) => {

        this.tariffData = data;

        this.roomCategories = data.filter(
          x => x.ChargeType === 'Room'
        );

        this.specialTreatments = data.filter(
          x => x.ChargeType === 'Treatment'
        );

        this.otherCharges = data.filter(
          x => x.ChargeType === 'OtherCharge'
        );

        if (data.length > 0) {
          this.tariffEffectiveFrom = data[0].EffectiveFrom;
        }

      },
      error => {
        console.log(error);
      }
    );

  }

  // Get User Details
  GetUserDetails() {
    this.IsEmailVerified = false;
    this.UpdateEmail = true;
    this.IsOTPSent = false;
    this.IsEmailVerified = false;
    this.loginService.GetUserDetails(this.globals.UserID).subscribe((data) => {
      this.OnlineUserRegistration = data[0];
    });
  }

  IsUserDetailsType = '';
  showUserDetails() {
    this.IsUserDetailsType = 'click';
    this.section = 'UserDetails';
    this.globals.IsUserDetailsUpdate = true;
    this.GetUserDetails();
  }
  disabledDates = [];
  getDoctorHoliday() {
    let a = this.Today;
    // ClientID, LocationID, CurrentDate, DoctorID
    const formatedDate = this.datePipe.transform(this.globals.CurrentDateTime, 'yyyy-MM-dd');
    this.bookingService.getDoctorHoliday(2, 2, formatedDate, 0).subscribe((res) => {
      this.disabledDates = res;
    });
  }

  CountryandNationality = [];
  // Get Country and Nationalty list from mstcountry
  GetCountryandNationality() {
    this.bookingloginService.GetCountryandNationality().subscribe(data => {
      this.CountryandNationality = data;
    });
  }

  //Getting State List
  getStateList() {
    this.commonService.GetStateList('State', '').subscribe(
      (data: any) => {
        this.States = data;
      }
    );
  }

  //Getting District List
  GetDistrictList(event) {
    let State = event.source.value;
    this.commonService.GetStateList('District', State).subscribe(
      (data: any) => {
        this.District = data;
      }
    );

  }

  //Getting City List
  GetCityList(event, param) {
    let State = param == 'Guest' ? event : this.OnlineUserRegistration.State;
    this.commonService.GetStateList('City', State).subscribe(
      (data: any) => {
        this.City = [];
        this.City = data;
      }
    );
  }

  advanceReceiptBook = 0;
  donationReceiptBook = 0;

  bookingAmount = 0;

  // Get configuration Details From mstclientconfiguration
  GetConfigurationDetails() {
    this.loginService.GetConfigurationDetails().subscribe(data => {
      this.configurationDetaild = data;
      this.bookingAmount = this.configurationDetaild[0]["BookingAmount"];
      this.CarmePaymentGateway_key = this.configurationDetaild[0]["PaymentGateway_key"];
      this.CarmePaymentGateway_secret = this.configurationDetaild[0]["PaymentGateway_secret"];
      this.CarmeApplication_ClientID = this.configurationDetaild[0]["Application_ClientID"];
      this.CarmeApplication_ClientSecret = this.configurationDetaild[0]["Application_ClientSecret"];
      const paymentReceiptBook = this.configurationDetaild[0]["PaymentReceiptBook"] != undefined
        && this.configurationDetaild[0]["PaymentReceiptBook"] != "" ? this.configurationDetaild[0]["PaymentReceiptBook"].split(",") : "";
      if (paymentReceiptBook.length > 0) {
        this.advanceReceiptBook = +paymentReceiptBook[0];
        this.donationReceiptBook = +paymentReceiptBook[1];
      }
      this.GetPaymentGatewayDetails();
    });
  }

  PaymentVerificationRequest = {
    'ThirdpartyPaymentID': '',
    'ThirdpartyPaymentOrderID': '',
    'razorpay_signature': '',
    'ClientSecret': ''
  };

  CarmePaymentGateway_key = "";
  CarmePaymentGateway_secret = "";
  CarmeApplication_ClientID = "";
  CarmeApplication_ClientSecret = "";
  ClientPublic_Token = "";
  ClientAccess_Token = "";
  ClientRefresh_Token = "";
  ClientExpires_In = 0;
  ClientPaymentGatewayTypeID = 0;
  ClientState = "";
  PaymentGateway = 0;
  paymentGatewaydetails = [];
  ThirdpartyPaymentID = "";
  ThirdpartyPaymentOrderID = "";

  // Getting Payment Gateway Details by ClientID and LocationID
  GetPaymentGatewayDetails() {
    this.PaymentGateway = 1;
    // Getting Token Expires Or Not
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      if (this.PaymentGateway != 0) {
        this.paymentGatewayService.GetPaymentGatewayDetails(2, 2, this.PaymentGateway).subscribe(data => {
          this.paymentGatewaydetails = data as string[];
          if (this.paymentGatewaydetails.length > 0) {
            // for website
            this.ClientPaymentGatewayTypeID = this.paymentGatewaydetails[0]["PaymentGatewayTypeID"];
            this.ClientExpires_In = this.paymentGatewaydetails[0]["Expires_In"];
            this.ClientPublic_Token = this.paymentGatewaydetails[0]["Public_Token"];
            this.ClientAccess_Token = this.paymentGatewaydetails[0]["Access_Token"];
            this.ClientRefresh_Token = this.paymentGatewaydetails[0]["Refresh_Token"];
            this.ClientState = this.paymentGatewaydetails[0]["State"];
          } else {
            this.ClientPublic_Token = "";
            this.ClientAccess_Token = "";
            this.ClientRefresh_Token = "";
            this.ClientExpires_In = 0;
            this.ClientPaymentGatewayTypeID = 0;
            this.ClientState = "";
          }
        });
      }
    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.GetPaymentGatewayDetails();
    }
  }

  // getting razorpay refresh token
  GetRazorpayRefreshToken() {
    // Getting Token Expires Or Not
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      this.paymentGatewayService.GetRazorpayRefreshToken(this.CarmeApplication_ClientID, this.CarmeApplication_ClientSecret, this.ClientRefresh_Token, this.ClientPaymentGatewayTypeID, this.globals.ClientID, this.globals.LocationID).subscribe((data: any) => {
        if (data == "OK") {
          this.GetPaymentGatewayDetails();
        }
      });
    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.GetRazorpayRefreshToken();
    }
  }

  isTokenExpired(expiresIn: number): boolean {
    const currentTime = new Date().getTime();
    const expirationTime = currentTime + expiresIn * 1000;
    return expirationTime < currentTime; // Returns true if expired
  }

  itemToEditRazorpayBookingAndYoga = {
    'Type': "Booking",
    'MinBedCount': 0,
    'ReceiptBookID': 0,
    'BookingID': 0,
    'BookingCode': '',
    'YogaBatchID': 0,
    'Access_Token': '',
    'SelectedClassID': 0,
    'selectedAliesName': '',
    'PaymentGateway_key': this.CarmePaymentGateway_key,
    'PaymentGateway_secret': this.CarmePaymentGateway_secret,
    'AdmissionDuration': 0,
    'StartDate': '',
    'ExpectedArival': '',
    'OnlinePatientRegistrationID': 0,
    'PatientID': 0,
    'CarryforwardBookingID': 0,
    'CarryForwardAmount': 0,
    'DeductionAmount': 0,
    'Amount': 0,
    'Currency': 'INR',
    'Receipt': 'order_rcpt_123',
    'Notes': 'Hospital bill payment',
    'IsRoomBook': false,
  };
  isPaymentHandled = false;

  CancellationandModificationPolicy(contentCancellationPolicy) {
    this.modalService.open(contentCancellationPolicy, { backdrop: 'static', size: 'md', backdropClass: 'modal-large', centered: true, keyboard: false });
  }

  IsPaymentScreen = false;
  // make payment with razorpay
  GetRazorpay() {
    // ── DUPLICATE PREVENTION: block double-click on Make Payment button ───────
    // A second click while Razorpay modal is already open would create a second
    // Razorpay order and a second webhook event, causing a duplicate booking.
    if (this.paymentInProgress) {
      this.toasterService.warning('Payment is already in progress. Please wait for the payment window.');
      return;
    }
    this.paymentInProgress = true;
    // ─────────────────────────────────────────────────────────────────────────
    //   "⚠️ Cancellation & Booking Modification Policy:\n\n" +
    //   "• 0% deduction if rescheduled or cancelled 15 days or more before check-in.\n" +
    //   "• 50% deduction if rescheduled or cancelled 7 to 14 days before check-in.\n" +
    //   "• 75% deduction if rescheduled or cancelled 3 to 6 days before check-in.\n" +
    //   "• 90% deduction if rescheduled or cancelled 1 to 2 days before check-in.\n" +
    //   "• 100% deduction on the day of check-in.\n\n" +
    //   "By proceeding with the payment, you agree to these terms."
    // )) {
    this.PaymentVerificationRequest = {
      'ThirdpartyPaymentID': '',
      'ThirdpartyPaymentOrderID': '',
      'razorpay_signature': '',
      'ClientSecret': ''
    };
    this.IsPaymentScreen = true;
    this.ThirdpartyPaymentID = "";
    this.ThirdpartyPaymentOrderID = "";
    this.bookingAmount = this.configurationDetaild[0]["BookingAmount"];
    debugger
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      if (this.ClientPublic_Token != "") {
        if (!this.isTokenExpired(this.ClientExpires_In)) {
          if (this.PreviousBalancewithBookingID.length > 0) {
            this.bookingAmount = this.bookingAmount - +this.PreviousBalancewithBookingID[0]['BalanceAmount'] < 0 ? 0 : this.bookingAmount - +this.PreviousBalancewithBookingID[0]['BalanceAmount'];
            this.itemToEditBooking.BookingCode = this.PreviousBalancewithBookingID[0]['BookingCode'];
            this.itemToEditBooking.CarryforwardBookingID = +this.PreviousBalancewithBookingID[0]['BookingID'];
            this.itemToEditBooking.CarryForwardAmount = +this.PreviousBalancewithBookingID[0]['BalanceAmount'];
          } else if (this.ResheduleBookingDetails && this.ResheduleBookingDetails['BookingID'] != undefined) {
            //this.bookingAmount = this.bookingAmount - +this.ResheduleBookingDetails['AdvanceAmount'];
            //this.itemToEditBooking.DeductionAmount = this.GetDeduction(this.ResheduleBookingDetails['CheckinDate'], this.Today, this.ResheduleBookingDetails['AdvanceAmount']);
            this.itemToEditBooking.DeductionAmount = 0;
            this.itemToEditBooking.BookingCode = this.ResheduleBookingDetails['BookingCode'];
            this.itemToEditBooking.CarryforwardBookingID = +this.ResheduleBookingDetails['BookingID'];
            //this.itemToEditBooking.CarryForwardAmount = +this.ResheduleBookingDetails['AdvanceAmount'] - +this.itemToEditBooking.DeductionAmount;
            this.itemToEditBooking.CarryForwardAmount = +this.ResheduleBookingDetails['AdvanceAmount'];
            this.itemToEditBooking.PaymentMode = this.ResheduleBookingDetails['PaymentMode'];
            // this.bookingAmount = this.bookingAmount - (+this.ResheduleBookingDetails['AdvanceAmount'] - +this.GetDeduction(this.ResheduleBookingDetails['CheckinDate'], this.Today, this.ResheduleBookingDetails['AdvanceAmount']));
            this.bookingAmount = this.bookingAmount - +this.ResheduleBookingDetails['AdvanceAmount'] < 0 ? 0 : this.bookingAmount - +this.ResheduleBookingDetails['AdvanceAmount'];
          }

          if (this.bookingAmount > 0 && this.ClientAccess_Token != "") {
            this.paymentGatewayService.createOrder(this.bookingAmount, this.CarmePaymentGateway_key, this.CarmePaymentGateway_secret, this.ClientAccess_Token).subscribe((order: any) => {
              if (order.id != null && order.id != "") {
                this.isPaymentHandled = false;
                const RozarpayOptions = {
                  amount: 100 * 100,
                  currency: 'INR',
                  name: 'Nisargopchar Ashram',
                  key: this.ClientPublic_Token,
                  order_id: order.id,
                  description: 'Advance Payment',
                  prefill: {
                    name: this.GuestQuetionaridetails[0]['FirstName'] + " " + this.GuestQuetionaridetails[0]['MiddleName'] + " " + this.GuestQuetionaridetails[0]['LastName'],
                    email: this.UserEmail,
                    contact: this.MobileNo,
                  },
                  theme: { color: '#6466e3' },
                  handler: (response: any) => {
                    this.itemToEditBooking.ThirdpartyPaymentID = response.razorpay_payment_id;
                    this.itemToEditBooking.ThirdpartyPaymentOrderID = response.razorpay_order_id;

                    this.PaymentVerificationRequest.ThirdpartyPaymentID = response.razorpay_payment_id;
                    this.PaymentVerificationRequest.ThirdpartyPaymentOrderID = response.razorpay_order_id;
                    this.PaymentVerificationRequest.razorpay_signature = response.razorpay_signature;
                    this.PaymentVerificationRequest.ClientSecret = this.CarmeApplication_ClientSecret;
                    this.itemToEditBooking.PaymentStatus = "Payment Successful";
                    alert("If your payment was successful but the booking is not yet visible, please wait a few moments. If the issue persists, contact the Nisargopachar team. Please do not attempt to book again.");
                    this.VerifyPaymentSignature();
                    this.IsPaymentScreen = false;
                  },
                  modal: {
                    ondismiss: () => {
                      this.itemToEditBooking.ThirdpartyPaymentOrderID = order.id;
                      this.itemToEditBooking.PaymentStatus = "Payment Cancel";
                      if (this.isPaymentHandled) return;
                      this.isPaymentHandled = true;
                      this.SaveFailedAndCancelPayment();
                      this.IsPaymentScreen = false;
                      // ── DUPLICATE PREVENTION ───────────────────────────
                      this.paymentInProgress = false;
                      // ──────────────────────────────────────────────────
                    }
                  }
                };

                const rzp = new Razorpay(RozarpayOptions);

                // ✅ Capture failed payment
                rzp.on('payment.failed', (response: any) => {
                  if (this.isPaymentHandled) return;
                  this.isPaymentHandled = true;
                  const failedPaymentDetails = {
                    code: response.error.code,
                    description: response.error.description,
                    source: response.error.source,
                    step: response.error.step,
                    reason: response.error.reason,
                    order_id: response.error.metadata?.order_id && response.error.metadata.order_id !== ''
                      ? response.error.metadata.order_id
                      : order.id,
                    payment_id: response.error.metadata?.payment_id || '',
                  };
                  this.itemToEditBooking.ThirdpartyPaymentID = failedPaymentDetails.payment_id;
                  this.itemToEditBooking.ThirdpartyPaymentOrderID = failedPaymentDetails.order_id;
                  this.itemToEditBooking.PaymentStatus = "Payment Failed";
                  this.IsPaymentScreen = false;
                  // ── DUPLICATE PREVENTION ─────────────────────────────
                  this.paymentInProgress = false;
                  // ────────────────────────────────────────────────────
                  //this.SaveFailedAndCancelPayment();

                });
                rzp.open();
              }
            });
          } else if (this.bookingAmount <= 0 && (this.PreviousBalancewithBookingID.length > 0 || (this.ResheduleBookingDetails && this.ResheduleBookingDetails['BookingID'] != undefined))) {
            this.itemToEditBooking.PaymentStatus = "Payment Successful";
            // if (this.ResheduleBookingDetails && this.ResheduleBookingDetails['BookingID'] !== undefined) {
            //   this.SaveRescheduleBooking();
            // } else {
            //   this.SaveBooking();
            // }
            this.SaveRescheduleBooking();
          } else {
            this.toasterService.warning("Something went wrong");
          }
        } else {
          this.GetRazorpayRefreshToken();
          this.GetRazorpay();
          this.IsPaymentScreen = false;
        }
      } else {
        let DeductionAmount = 0;
        debugger
        if (this.PreviousBalancewithBookingID.length > 0) {
          this.bookingAmount = this.bookingAmount - +this.PreviousBalancewithBookingID[0]['BalanceAmount'] < 0 ? 0 : this.bookingAmount - +this.PreviousBalancewithBookingID[0]['BalanceAmount'];
          this.itemToEditBooking.BookingCode = this.PreviousBalancewithBookingID[0]['BookingCode'];
          this.itemToEditBooking.CarryforwardBookingID = +this.PreviousBalancewithBookingID[0]['BookingID'];
          this.itemToEditBooking.CarryForwardAmount = +this.PreviousBalancewithBookingID[0]['BalanceAmount'];
        } else if (this.ResheduleBookingDetails && this.ResheduleBookingDetails['BookingID'] != undefined) {
          //DeductionAmount = +this.GetDeduction(this.ResheduleBookingDetails['CheckinDate'], this.Today, this.ResheduleBookingDetails['AdvanceAmount']);
          DeductionAmount = 0;
          this.itemToEditBooking.BookingCode = this.ResheduleBookingDetails['BookingCode'];
          this.itemToEditBooking.DeductionAmount = DeductionAmount;
          this.itemToEditBooking.CarryforwardBookingID = +this.ResheduleBookingDetails['BookingID'];
          //this.itemToEditBooking.CarryForwardAmount = +this.ResheduleBookingDetails['AdvanceAmount'] - +this.itemToEditBooking.DeductionAmount;
          this.itemToEditBooking.CarryForwardAmount = +this.ResheduleBookingDetails['AdvanceAmount'];
          this.itemToEditBooking.PaymentMode = this.ResheduleBookingDetails['PaymentMode'];
          //this.bookingAmount = this.bookingAmount - +this.ResheduleBookingDetails['AdvanceAmount'];
          //this.bookingAmount = this.bookingAmount - (+this.ResheduleBookingDetails['AdvanceAmount'] - +this.GetDeduction(this.ResheduleBookingDetails['CheckinDate'], this.Today, this.ResheduleBookingDetails['AdvanceAmount']));
          this.bookingAmount = this.bookingAmount - +this.ResheduleBookingDetails['AdvanceAmount'] < 0 ? 0 : this.bookingAmount - +this.ResheduleBookingDetails['AdvanceAmount'];
        } else {
          this.itemToEditBooking.CarryforwardBookingID = 0;
          this.itemToEditBooking.CarryForwardAmount = 0;
        }
        let PatientID = this.GuestQuetionaridetails[0]['PatientID'] == null || this.GuestQuetionaridetails[0]['PatientID'] == '' ? 0 : this.GuestQuetionaridetails[0]['PatientID'];
        if (this.SelectedOnlinePatientRegistrationID != 0) {
          if (this.bookingAmount > 0 && this.CarmePaymentGateway_key != "") {
            this.itemToEditBooking.MinBedCount = this.GetlowestNumber(this.SelectedRow[0]);
            this.itemToEditBooking.SelectedClassID = this.SelectedClassID;
            this.itemToEditBooking.ExpectedArival = this.datePipe.transform(this.itemToEditBooking.ExpectedArival, 'yyyy-MM-dd HH:mm:ss');
            this.itemToEditBooking.CheckinDate = this.datePipe.transform(this.checkinDate, 'yyyy-MM-dd');
            // if (this.PreviousBalancewithBookingID != null && this.PreviousBalancewithBookingID.length > 0) {
            //   this.itemToEditBooking.CarryforwardBookingID = +this.PreviousBalancewithBookingID[0]['BookingID'];
            //   this.itemToEditBooking.CarryForwardAmount = +this.PreviousBalancewithBookingID[0]['BalanceAmount'];
            // } else {
            //   this.itemToEditBooking.CarryforwardBookingID = 0;
            //   this.itemToEditBooking.CarryForwardAmount = 0;
            // }
            this.itemToEditRazorpayBookingAndYoga = {
              'Type': "Booking",
              'MinBedCount': this.itemToEditBooking.MinBedCount,
              'ReceiptBookID': this.advanceReceiptBook,
              'BookingID': this.BookingID,
              'BookingCode': this.itemToEditBooking.BookingCode,
              'YogaBatchID': 0,
              'Access_Token': this.ClientAccess_Token,
              'PaymentGateway_key': this.CarmePaymentGateway_key,
              'PaymentGateway_secret': this.CarmePaymentGateway_secret,
              'AdmissionDuration': this.AdmissionDuration,
              'ExpectedArival': this.itemToEditBooking.ExpectedArival,
              'StartDate': this.itemToEditBooking.CheckinDate,
              'SelectedClassID': this.SelectedClassID,
              'selectedAliesName': this.selectedAliesName,
              'OnlinePatientRegistrationID': this.SelectedOnlinePatientRegistrationID,
              'PatientID': PatientID,
              'CarryforwardBookingID': +this.itemToEditBooking.CarryforwardBookingID,
              'CarryForwardAmount': +this.itemToEditBooking.CarryForwardAmount,
              'DeductionAmount': DeductionAmount,
              'Amount': this.bookingAmount,
              'Currency': 'INR',
              'Receipt': 'order_rcpt_123',
              'Notes': 'Hospital bill payment',
              'IsRoomBook': this.itemToEditBooking.IsRoomBook,
            };


            this.paymentGatewayService.CreateOrderWithKeySecret(this.itemToEditRazorpayBookingAndYoga).subscribe((order: any) => {
              if (order.id != null && order.id != "") {
                this.isPaymentHandled = false;
                const RozarpayOptions = {
                  amount: 100 * 100,
                  currency: 'INR',
                  name: 'Nisargopchar Ashram',
                  key: this.CarmePaymentGateway_key,
                  order_id: order.id,
                  description: 'Advance Payment',
                  prefill: {
                    name: this.GuestQuetionaridetails[0]['FirstName'] + " " + this.GuestQuetionaridetails[0]['MiddleName'] + " " + this.GuestQuetionaridetails[0]['LastName'],
                    email: this.UserEmail,
                    contact: this.MobileNo,
                  },
                  theme: { color: '#6466e3' },
                  handler: (response: any) => {
                    this.itemToEditBooking.ThirdpartyPaymentID = response.razorpay_payment_id;
                    this.itemToEditBooking.ThirdpartyPaymentOrderID = response.razorpay_order_id;

                    this.PaymentVerificationRequest.ThirdpartyPaymentID = response.razorpay_payment_id;
                    this.PaymentVerificationRequest.ThirdpartyPaymentOrderID = response.razorpay_order_id;
                    this.PaymentVerificationRequest.razorpay_signature = response.razorpay_signature;
                    this.PaymentVerificationRequest.ClientSecret = this.CarmeApplication_ClientSecret;
                    this.itemToEditBooking.PaymentStatus = "Payment Successful";
                    if (!this.IsHoldPatient) {
                      this.saveQuestionnaire('');
                    }
                    this.IsPaymentScreen = false;
                    // ── DUPLICATE PREVENTION: reset on any payment outcome ──────
                    this.paymentInProgress = false;
                    // ────────────────────────────────────────────────────────────
                    // this.VerifyPaymentSignature();
                    this.toasterService.success("Record Save Successfully!!");
                    this.isregister = false;
                    this.isbooknow = false;
                    this.itemToEditBooking.IsRoomBook = false;
                    this.BookingID = 0;
                    this.SelectedClassID = 0;
                    this.checkinDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
                    this.AdmissionDuration = this.minDuration;
                    this.isFinalPayment = false;
                    this.itemToEditBooking.ThirdpartyPaymentID = '';
                    this.itemToEditBooking.ThirdpartyPaymentOrderID = '';
                    alert("If your payment was successful but the booking is not yet visible, please wait a few moments. If the issue persists, contact the Nisargopachar team. Please do not attempt to book again.");
                    this.GetPatientHistoryQuestionary(this.SelectedOnlinePatientRegistrationID);
                  },
                  modal: {
                    ondismiss: () => {
                      this.itemToEditBooking.ThirdpartyPaymentOrderID = order.id;
                      this.itemToEditBooking.PaymentStatus = "Payment Cancel";
                      if (this.isPaymentHandled) return;
                      this.isPaymentHandled = true;
                      this.SaveFailedAndCancelPayment();
                      this.IsPaymentScreen = false;
                      // ── DUPLICATE PREVENTION ─────────────────────────────
                      this.paymentInProgress = false;
                      // ────────────────────────────────────────────────────
                    }
                  }
                };

                const rzp = new Razorpay(RozarpayOptions);

                // ✅ Capture failed payment
                rzp.on('payment.failed', (response: any) => {
                  if (this.isPaymentHandled) return;
                  this.isPaymentHandled = true;
                  const failedPaymentDetails = {
                    code: response.error.code,
                    description: response.error.description,
                    source: response.error.source,
                    step: response.error.step,
                    reason: response.error.reason,
                    order_id: response.error.metadata?.order_id && response.error.metadata.order_id !== ''
                      ? response.error.metadata.order_id
                      : order.id,
                    payment_id: response.error.metadata?.payment_id || '',
                  };
                  this.itemToEditBooking.ThirdpartyPaymentID = failedPaymentDetails.payment_id;
                  this.itemToEditBooking.ThirdpartyPaymentOrderID = failedPaymentDetails.order_id;
                  this.itemToEditBooking.PaymentStatus = "Payment Failed";
                  //this.SaveFailedAndCancelPayment();
                  this.itemToEditBooking.ThirdpartyPaymentID = '';
                  this.itemToEditBooking.ThirdpartyPaymentOrderID = '';
                  this.IsPaymentScreen = false;
                  // ── DUPLICATE PREVENTION ─────────────────────────────
                  this.paymentInProgress = false;
                  // ────────────────────────────────────────────────────
                });
                rzp.open();
              }
            });
          } else if (this.bookingAmount <= 0 && (this.PreviousBalancewithBookingID.length > 0 || (this.ResheduleBookingDetails && this.ResheduleBookingDetails['BookingID'] != undefined))) {
            this.itemToEditBooking.PaymentStatus = "Payment Successful";
            // if (this.ResheduleBookingDetails && this.ResheduleBookingDetails['BookingID'] !== undefined) {
            //   this.SaveRescheduleBooking();
            // } else {
            //   this.SaveBooking();
            // }
            this.SaveRescheduleBooking();

          } else {
            this.toasterService.warning("Please log out and try again!!");
          }
        } else {
          this.toasterService.warning("Please log out and try again!!");
        }
      }

    } else {
      this.GetRefreshToken();
      this.GetRazorpay();
      this.IsPaymentScreen = false;
    }
  }

  // Save Failed And Cancel Payment Entery in trnpayment
  SaveFailedAndCancelPayment() {
    this.itemToEditBooking.BookingID = this.BookingID;
    this.itemToEditBooking.BookingStatus = 'Unutilized by the Patient/guest';
    this.itemToEditBooking.UHID = +this.GuestQuetionaridetails[0]['UHID'];
    this.itemToEditBooking.PatientFullName = this.GuestQuetionaridetails[0]['Prefix'] + ' ' + this.GuestQuetionaridetails[0]['FirstName'] + ' ' + this.GuestQuetionaridetails[0]['MiddleName'] + ' ' + this.GuestQuetionaridetails[0]['LastName'];
    this.itemToEditBooking.WAGSM = this.GuestQuetionaridetails[0]['WAGSM'] != "" ? this.GuestQuetionaridetails[0]['WAGSM'] : this.GuestQuetionaridetails[0]['GSM'];
    this.itemToEditBooking.PatientID = this.GuestQuetionaridetails[0]['PatientID'];
    this.itemToEditBooking.AadharNo = this.GuestQuetionaridetails[0]['AadharNo'];
    this.itemToEditBooking.PassportNo = this.GuestQuetionaridetails[0]['PassportNo'];
    this.itemToEditBooking.PinCode = this.GuestQuetionaridetails[0]['PinCode'];
    this.itemToEditBooking.PreferredLanguage = this.GuestQuetionaridetails[0]['PreferredLanguage'];
    this.itemToEditBooking.SelectedClassID = this.SelectedClassID;
    this.itemToEditBooking.Classname = this.SelectedRow[0]['Healing retreat'];
    this.itemToEditBooking.AdmissionDuration = this.AdmissionDuration;
    this.itemToEditBooking.selectedRate = this.selectedRate;
    this.itemToEditBooking.CarmePaymentGateway_key = this.CarmePaymentGateway_key;
    this.itemToEditBooking.CarmePaymentGateway_secret = this.CarmePaymentGateway_secret;
    this.itemToEditBooking.TotalAmount = this.TotalAmount;
    this.itemToEditBooking.ExpectedArival = this.datePipe.transform(this.itemToEditBooking.ExpectedArival, 'yyyy-MM-dd HH:mm:ss');
    this.itemToEditBooking.BookingType = "Online";
    this.itemToEditBooking.ClientID = 2;
    this.itemToEditBooking.UserID = this.OnlineUserRegistration.UserID;
    this.itemToEditBooking.LocationID = 2;
    this.itemToEditBooking.SelectedOnlinePatientRegistrationID = this.SelectedOnlinePatientRegistrationID;
    this.itemToEditBooking.BookingDate = this.Today;
    this.itemToEditBooking.CheckinDate = this.datePipe.transform(this.checkinDate, 'yyyy-MM-dd');
    this.itemToEditBooking.ReceiptBookID = 0;
    this.itemToEditBooking.Amount = this.bookingAmount;
    if (this.PreviousBalancewithBookingID.length > 0) {
      this.itemToEditBooking.CarryforwardBookingID = +this.PreviousBalancewithBookingID[0]['BookingID'];
      this.itemToEditBooking.CarryForwardAmount = +this.PreviousBalancewithBookingID[0]['BalanceAmount'];
    } else {
      this.itemToEditBooking.CarryforwardBookingID = 0;
      this.itemToEditBooking.CarryForwardAmount = 0;
    }


    this.itemToEditBooking.LogValue = 'OnlinePatientRegistrationID: ' + this.itemToEditBooking.OnlinePatientRegistrationID +
      ' ,BookingID: ' + this.itemToEditBooking.BookingID +
      ' ,BookingDate: ' + this.Today +
      ' ,Aadhar: ' + this.itemToEditBooking.AadharNo +
      ' ,PassportNo: ' + this.itemToEditBooking.PassportNo +
      ' ,PinCode: ' + this.itemToEditBooking.PinCode;

    this.bookingloginService.SaveFailedAndCancelPayment(this.itemToEditBooking).subscribe((data) => {
      if (data == "OK") {
        this.itemToEditBooking.ThirdpartyPaymentID = '';
        this.itemToEditBooking.ThirdpartyPaymentOrderID = '';
      }
    });
  }

  // Razorpay Verify Payment Signature
  VerifyPaymentSignature() {
    // Getting Token Expires Or Not
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      if (this.PaymentVerificationRequest.ThirdpartyPaymentID != "" && this.PaymentVerificationRequest.ThirdpartyPaymentOrderID != ""
        && this.PaymentVerificationRequest.razorpay_signature != "" && this.PaymentVerificationRequest.ClientSecret != "") {
        this.paymentGatewayService.VerifyPaymentSignature(this.PaymentVerificationRequest).subscribe((data) => {
          this.isInProgress = false;
          if (data != undefined && data != null) {
            if (data == 'OK') {
              // this.globals.ShowToastrMessage("success", "Payment Successful!");
              if (this.ResheduleBookingDetails && this.ResheduleBookingDetails['BookingID'] !== undefined) {
                this.SaveRescheduleBooking();
              } else {
                this.SaveBooking();
              }
            }
            else {
              this.globals.ShowToastrMessage("error", this.messages["msg_Exception"]);
            }
          }
          this.isInProgress = false;
        });
      }
    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.VerifyPaymentSignature();
    }
  }

  itemToEditBooking = {
    'Type': "Booking",
    'PaymentID': 0,
    'ReceiptBookID': 0,
    'ReceiptNo': 0,
    'BookingID': 0,
    'DonationID': 0,
    'Amount': this.bookingAmount,
    'RefundID': 0,
    'RefundAmount': 0,
    'Remark': '',
    'BookingCode': '',
    'ThirdpartyPaymentOrderID': '',
    'ThirdpartyPaymentID': '',
    'CarmePaymentGateway_key': this.CarmePaymentGateway_key,
    'CarmePaymentGateway_secret': this.CarmePaymentGateway_secret,
    'SelectedOnlinePatientRegistrationID': 0,
    'SelectedClassID': 0,
    'BookingDate': "",
    'CheckinDate': "",
    'AdmissionDuration': 0,
    'TotalAmount': 0,
    'selectedRate': 0,
    'OnlinePatientRegistrationID': '',
    'OnlineUserRegistrationID': 0,
    'UHID': 0,
    'PatientID': 0,
    'PatientFullName': '',
    'UserID': '',
    'WAGSM': '',
    'MinBedCount': 0,
    'AadharNo': '',
    'PassportNo': '',
    'PinCode': '',
    'PreferredLanguage': '',
    'RelationWithUser': '',
    'MigratedToUHID': 0,
    'CarryforwardBookingID': 0,
    'CarryForwardAmount': 0,
    'LogValue': '',
    'PaymentMode': '',
    'UserName': '',
    'BlackListed': false,
    'Activate': true,
    'ClientID': 2,
    'LocationID': 2,
    'BookingType': "Online",
    'DeductionAmount': 0,
    "Classname": "",
    "Rate": 0,
    'IsRoomBook': false,
    "PatientSource": '',
    "ExpectedArival": '',
    "PatientSourceLocation": '',
    "Synchronized": false,
    'BookingStatus': '',
    'PaymentStatus': '',
  };

  IsPayment = false;
  // This function saves Booking
  SaveBooking() {
    this.itemToEditBooking.MinBedCount = this.GetlowestNumber(this.SelectedRow[0]);
    this.itemToEditBooking.BookingID = this.BookingID;
    this.itemToEditBooking.BookingStatus = 'Unutilized by the Patient/guest';
    this.itemToEditBooking.SelectedClassID = this.SelectedClassID;
    this.itemToEditBooking.UserID = this.OnlineUserRegistration.UserID;
    this.itemToEditBooking.Classname = this.selectedAliesName;
    this.itemToEditBooking.AdmissionDuration = this.AdmissionDuration;
    this.itemToEditBooking.selectedRate = this.selectedRate;
    this.itemToEditBooking.CarmePaymentGateway_key = this.CarmePaymentGateway_key;
    this.itemToEditBooking.CarmePaymentGateway_secret = this.CarmePaymentGateway_secret;
    this.itemToEditBooking.TotalAmount = this.TotalAmount;
    this.itemToEditBooking.ExpectedArival = this.datePipe.transform(this.itemToEditBooking.ExpectedArival, 'yyyy-MM-dd HH:mm:ss');
    this.itemToEditBooking.BookingType = "Online";
    this.itemToEditBooking.ClientID = 2;
    this.itemToEditBooking.LocationID = 2;
    this.itemToEditBooking.SelectedOnlinePatientRegistrationID = this.SelectedOnlinePatientRegistrationID;
    this.itemToEditBooking.BookingDate = this.Today;
    this.itemToEditBooking.CheckinDate = this.datePipe.transform(this.checkinDate, 'yyyy-MM-dd');
    this.itemToEditBooking.ReceiptBookID = this.advanceReceiptBook;
    this.itemToEditBooking.Amount = this.bookingAmount;
    if (this.PreviousBalancewithBookingID != null && this.PreviousBalancewithBookingID.length > 0) {
      this.itemToEditBooking.CarryforwardBookingID = +this.PreviousBalancewithBookingID[0]['BookingID'];
      this.itemToEditBooking.CarryForwardAmount = +this.PreviousBalancewithBookingID[0]['BalanceAmount'];
    } else {
      this.itemToEditBooking.CarryforwardBookingID = 0;
      this.itemToEditBooking.CarryForwardAmount = 0;
    }


    this.itemToEditBooking.LogValue = 'OnlinePatientRegistrationID: ' + this.itemToEditBooking.OnlinePatientRegistrationID +
      ' ,BookingID: ' + this.itemToEditBooking.BookingID +
      ' ,BookingDate: ' + this.Today +
      ' ,Aadhar: ' + this.itemToEditBooking.AadharNo +
      ' ,PassportNo: ' + this.itemToEditBooking.PassportNo +
      ' ,PinCode: ' + this.itemToEditBooking.PinCode;
    this.IsPayment = true;
    this.bookingloginService.SaveBooking(this.itemToEditBooking).subscribe((data) => {
      if (data != null && data.includes("OK")) {
        // this.SelectedOnlinePatientRegistrationID = 0;
        this.isregister = false;
        this.isbooknow = false;
        this.itemToEditBooking.IsRoomBook = false;
        this.LoadGuest();
        this.SelectedClassID = 0;
        this.IsReSchedule = false;
        this.checkinDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
        this.AdmissionDuration = this.minDuration;
        this.isFinalPayment = false;
        this.toasterService.success("Record Save Successfully!!");
        this.itemToEditBooking.ThirdpartyPaymentID = '';
        this.itemToEditBooking.ThirdpartyPaymentOrderID = '';
        let BookingID = data.split('$')[1];
        this.Questionnaire = this.Questionnaire.map(q => ({
          ...q,
          BookingID: BookingID
        }));
        // if (!this.IsHoldPatient) {
        //   this.saveQuestionnaire();
        // } else {
        this.UpdateBookingIDforQuestionnaire(this.BookingID, BookingID);
        this.BookingID = 0;
        // }
        //if (this.itemToEditBooking.BookingID == 0) {
        this.GetPatientHistoryQuestionary(this.SelectedOnlinePatientRegistrationID);
        //}
        this.IsPayment = false;
      }
      else {
        this.IsPayment = false;
        this.toasterService.error('Something went wrong');
      }
    });
  }

  // Update BookingID in Booking Questionnaire for hold Patient
  UpdateBookingIDforQuestionnaire(OldBookingID, BookingID) {
    this.bookingloginService.UpdateBookingIDforQuestionnaire(this.SelectedOnlinePatientRegistrationID, OldBookingID, BookingID).subscribe((data) => {
      if (data == "OK") {
      }
    });
  }

  // This function saves Rescheduled Booking
  SaveRescheduleBooking() {
    this.itemToEditBooking.BookingID = this.BookingID;
    this.itemToEditBooking.BookingStatus = 'Unutilized by the Patient/guest';
    this.itemToEditBooking.UHID = +this.GuestQuetionaridetails[0]['UHID'];
    this.itemToEditBooking.PatientFullName = this.GuestQuetionaridetails[0]['Prefix'] + ' ' + this.GuestQuetionaridetails[0]['FirstName'] + ' ' + this.GuestQuetionaridetails[0]['MiddleName'] + ' ' + this.GuestQuetionaridetails[0]['LastName'];
    this.itemToEditBooking.WAGSM = this.GuestQuetionaridetails[0]['WAGSM'] != "" ? this.GuestQuetionaridetails[0]['WAGSM'] : this.GuestQuetionaridetails[0]['GSM'];
    this.itemToEditBooking.PatientID = this.GuestQuetionaridetails[0]['PatientID'];
    this.itemToEditBooking.AadharNo = this.GuestQuetionaridetails[0]['AadharNo'];
    this.itemToEditBooking.PassportNo = this.GuestQuetionaridetails[0]['PassportNo'];
    this.itemToEditBooking.PinCode = this.GuestQuetionaridetails[0]['PinCode'];
    this.itemToEditBooking.PreferredLanguage = this.GuestQuetionaridetails[0]['PreferredLanguage'];
    this.itemToEditBooking.SelectedClassID = this.SelectedClassID;
    this.itemToEditBooking.Classname = this.SelectedRow[0]['Healing retreat'];
    this.itemToEditBooking.AdmissionDuration = this.AdmissionDuration;
    this.itemToEditBooking.UserID = this.OnlineUserRegistration.UserID;
    this.itemToEditBooking.selectedRate = this.selectedRate;
    this.itemToEditBooking.CarmePaymentGateway_key = this.CarmePaymentGateway_key;
    this.itemToEditBooking.CarmePaymentGateway_secret = this.CarmePaymentGateway_secret;
    this.itemToEditBooking.TotalAmount = this.TotalAmount;
    this.itemToEditBooking.ExpectedArival = this.datePipe.transform(this.itemToEditBooking.ExpectedArival, 'yyyy-MM-dd HH:mm:ss');
    this.itemToEditBooking.BookingType = "Online";
    this.itemToEditBooking.ClientID = 2;
    this.itemToEditBooking.LocationID = 2;
    this.itemToEditBooking.SelectedOnlinePatientRegistrationID = this.SelectedOnlinePatientRegistrationID;
    this.itemToEditBooking.BookingDate = this.Today;
    this.itemToEditBooking.CheckinDate = this.datePipe.transform(this.checkinDate, 'yyyy-MM-dd');
    this.itemToEditBooking.ReceiptBookID = this.advanceReceiptBook;
    this.itemToEditBooking.Amount = this.bookingAmount;
    if (this.ResheduleBookingDetails && this.ResheduleBookingDetails['BookingID'] !== undefined) {
      //this.itemToEditBooking.DeductionAmount = this.GetDeduction(this.ResheduleBookingDetails['CheckinDate'], this.Today, this.ResheduleBookingDetails['AdvanceAmount']);
      this.itemToEditBooking.DeductionAmount = 0;
      this.itemToEditBooking.CarryforwardBookingID = +this.ResheduleBookingDetails['BookingID'];
      this.itemToEditBooking.CarryForwardAmount = +this.ResheduleBookingDetails['AdvanceAmount'] - +this.itemToEditBooking.DeductionAmount;
      this.itemToEditBooking.CarryForwardAmount = +this.ResheduleBookingDetails['AdvanceAmount'];
      this.itemToEditBooking.PaymentMode = this.ResheduleBookingDetails['PaymentMode'];
    } else if (this.PreviousBalancewithBookingID && this.PreviousBalancewithBookingID.length > 0) {
      this.itemToEditBooking.BookingCode = this.PreviousBalancewithBookingID[0]['BookingCode'];
      this.itemToEditBooking.PaymentMode = this.PreviousBalancewithBookingID[0]['PaymentMode'];
      this.itemToEditBooking.CarryforwardBookingID = +this.PreviousBalancewithBookingID[0]['BookingID'];
      this.itemToEditBooking.CarryForwardAmount = +this.PreviousBalancewithBookingID[0]['BalanceAmount'];
    } else {
      this.itemToEditBooking.CarryforwardBookingID = 0;
      this.itemToEditBooking.CarryForwardAmount = 0;
    }

    this.itemToEditBooking.LogValue = 'OnlinePatientRegistrationID: ' + this.itemToEditBooking.OnlinePatientRegistrationID +
      ' ,BookingID: ' + this.itemToEditBooking.BookingID +
      ' ,BookingDate: ' + this.Today +
      ' ,Aadhar: ' + this.itemToEditBooking.AadharNo +
      ' ,PassportNo: ' + this.itemToEditBooking.PassportNo +
      ' ,PinCode: ' + this.itemToEditBooking.PinCode;
    this.IsPayment = true;
    this.bookingloginService.SaveRescheduleBooking(this.itemToEditBooking).subscribe((data) => {
      if (data.includes("OK")) {
        // this.SelectedOnlinePatientRegistrationID = 0;
        this.isregister = false;
        this.isbooknow = false;
        this.BookingID = 0;
        this.LoadGuest();
        this.IsReSchedule = false;
        this.SelectedClassID = 0;
        this.checkinDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
        this.AdmissionDuration = this.minDuration;
        this.isFinalPayment = false;
        this.IsPayment = false;
        this.toasterService.success("Record Save Successfully!!");
      }
      else {
        this.IsPayment = false;
        this.toasterService.error('Something went wrong');
      }
      this.IsPaymentScreen = false;
    });
  }

  itemToEditPatientHistory = {

    'OnlinePatientRegistrationID': 0,
    'PatientID': 0,
    QuestionnaireItem: [{
      'BookingQuestionnaireID': 0,
      'QuestionnaireID': 0,
      'Category': '',
      'LabelName': '',
      'Question': '',
      'Answer': '',
      'OldAnswer': '',
      'AnswerType': '',
      'SelectedAnswer': '',
      'TextAnswer': '',
      'SelectedDate': '',
      'Activate': true,
    }],
  }

  QuestionaryLanguageType = 'Hindi';
  IsPatientHistorySheet = false;
  // Getting Applicant online admission eligibility form quetions
  GetPatientHistoryQuestionary(SelectedOnlinePatientRegistrationID) {
    if (this.GuestQuetionaridetails.length <= 0) {
      let result = this.items.filter((x) => x["OnlinePatientRegistrationID"] == SelectedOnlinePatientRegistrationID);
      this.SelectedOnlinePatientRegistrationID = SelectedOnlinePatientRegistrationID;
      this.GuestQuetionaridetails = result;
    }
    this.isBookingHistory = false;
    this.IsPatientHistorySheet = true;
    this.commonService.GetQuestionnaire(SelectedOnlinePatientRegistrationID, 'EHR', '', this.QuestionaryLanguageType).subscribe(data => {
      if (data != undefined && data.length > 0) {
        this.itemToEditPatientHistory.QuestionnaireItem = data;
        this.itemToEditPatientHistory.OnlinePatientRegistrationID = SelectedOnlinePatientRegistrationID;
      } else {
        this.itemToEditPatientHistory.QuestionnaireItem = [];
      }
    });
    this.pageHitCount('/session/booking-login/booking-login/PatientHistoryQuestionary');
  }

  selectedindex: number;
  GetQuestionByID(index) {
    this.selectedindex = index;
    this.itemToEditPatientHistory.QuestionnaireItem[index].Answer = this.itemToEditPatientHistory.QuestionnaireItem[index].OldAnswer;
  }

  //Remove answer from selected answer
  removeAnswer(i, Answer, label) {
    let parts = this.itemToEditPatientHistory.QuestionnaireItem[i].SelectedAnswer.split('#');

    const indexToRemove = parts.indexOf(label);
    if (indexToRemove !== -1) {
      parts.splice(indexToRemove, 1);
    }
    this.itemToEditPatientHistory.QuestionnaireItem[i].SelectedAnswer = parts.join('#');
    event.stopPropagation();
  }

  //Funtion use for answer selection in the table of trnQuestionnaire.
  SetAnswerData(index, SAnswer, AnswerType, Validation) {
    let parts = this.itemToEditPatientHistory.QuestionnaireItem[index].Answer.split('#');
    const indexToRemove = parts.indexOf(SAnswer);
    if (indexToRemove !== -1) {
      parts.splice(indexToRemove, 1);
    }
    this.itemToEditPatientHistory.QuestionnaireItem[index].Answer = parts.join('#');
    if (AnswerType == 1) {   //Single Choice
      this.itemToEditPatientHistory.QuestionnaireItem[index].Answer = "";
      this.itemToEditPatientHistory.QuestionnaireItem[index].SelectedAnswer = "";
      this.itemToEditPatientHistory.QuestionnaireItem[index].SelectedAnswer = SAnswer;
    } else if (AnswerType == 2) { // Multiple Choice
      this.itemToEditPatientHistory.QuestionnaireItem[index].SelectedAnswer = this.itemToEditPatientHistory.QuestionnaireItem[index].SelectedAnswer == "" ? SAnswer : this.itemToEditPatientHistory.QuestionnaireItem[index].SelectedAnswer + "#" + SAnswer;
    } else if (AnswerType == 3) { //  Text
    } else if (AnswerType == 4) {
      //  Single choice + Text
      this.itemToEditPatientHistory.QuestionnaireItem[index].Answer = "";
      this.itemToEditPatientHistory.QuestionnaireItem[index].SelectedAnswer = "";
      this.itemToEditPatientHistory.QuestionnaireItem[index].SelectedAnswer = SAnswer;
    } else if (AnswerType == 5) { //  Multiple choice + Text
      this.itemToEditPatientHistory.QuestionnaireItem[index].SelectedAnswer = this.itemToEditPatientHistory.QuestionnaireItem[index].SelectedAnswer == "" ? SAnswer : this.itemToEditPatientHistory.QuestionnaireItem[index].SelectedAnswer + "#" + SAnswer;
    }
    event.stopPropagation();
  }

  //Save all questions of Patient in database
  SaveCasepaperQuestionnaire() {
    if (this.itemToEditPatientHistory.OnlinePatientRegistrationID != 0) {
      this.itemToEditPatientHistory.PatientID = +this.GuestQuetionaridetails[0]['PatientID'];
      this.isInProgress = true;
      let FillQuestion = this.itemToEditPatientHistory.QuestionnaireItem.filter(x => x['SelectedAnswer'] != '' || x['TextAnswer'] != '');
      if (FillQuestion.length > 0) {
        this.bookingloginService.SavePatientHistorySheetQuestionnaire(this.itemToEditPatientHistory).subscribe((data) => {
          if (data != undefined && data != null) {
            if (data == 'OK') {
              this.toasterService.success("Record Save Successfully!!");
              this.IsPatientHistorySheet = false;
              this.LoadGuest();
              this.selectedindex = -1;
              this.SelectedOnlinePatientRegistrationID = 0;
              this.itemToEditPatientHistory.QuestionnaireItem = [];
            }
            else {
              this.toasterService.error("Something went wrong!!");
            }
          }
          this.isInProgress = false;
        });
      } else {
        this.isInProgress = false;
        this.toasterService.warning("Please fill at least one answer!!");
      }
    } else {
      this.toasterService.error("Something went wrong!!");
    }
  }

  BookingID = 0;
  IsReSchedule = false;
  ResheduleBookingDetails = [];
  RescheduleBooking(item, BookingID) {
    // let deductedAmount = this.GetDeduction(item['CheckinDate'], this.Today, item['AdvanceAmount']);
    // let finalAmount = +item['AdvanceAmount'] - deductedAmount;
    // const conf = confirm(
    //   "Your total advance payment is " + item['AdvanceAmount'] + ".\n" +
    //   "An amount of " + deductedAmount + " will be deducted from it, and the remaining amount of " + finalAmount + " will be carried forward to your next booking.\n\n" +
    //   "To reschedule your booking, you will need to pay the remaining balance.\n\n" +
    //   "Would you like to proceed?"
    // );
    // if (conf) {
    this.ClearBedFilter();
    this.BookingID = BookingID;
    this.IsReSchedule = true;
    this.ResheduleBookingDetails = item;
    this.isBookingHistory = false;
    this.paymentInProgress = false;
    this.isregister = true;
    this.isBookingQuetionary = false;
    //this.isregister = true;
    //this.CheckAvailability();
    // }
  }

  maxDate(): string {
    const threeMonthsLater = new Date();
    threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3);
    return this.datePipe.transform(threeMonthsLater, 'yyyy-MM-dd');
  }
  genders = [
    { value: 'MALE', description: 'MALE' },
    { value: 'FEMALE', description: 'FEMALE' },
    { value: 'TRANSGENDER', description: 'TRANSGENDER' }
  ];

  MobileNo = '';
  UserMobile = '';
  isInProgressRegister = false;
  IsRegistrationDone = false;
  //register method is used to sign up on the template.
  register(Type) {
    this.issignin = false;
    this.OnlineUserRegistration.Type = Type;
    this.ngForm.value.Type = Type;
    this.Today = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
    if (Type == 'R') { // for user Registartion
      if ((this.OnlineUserRegistration.Password.trim() != "" && this.OnlineUserRegistration.Password != null) &&
        (this.OnlineUserRegistration.ConfirmPassword.trim() != "" && this.OnlineUserRegistration.ConfirmPassword != null) &&
        this.OnlineUserRegistration.Password == this.OnlineUserRegistration.ConfirmPassword) {
        if (this.OnlineUserRegistration.MobileNo.trim() != "" && this.OnlineUserRegistration.MobileNo != null &&
          this.OnlineUserRegistration.Email.trim() != "" && this.OnlineUserRegistration.Email != null) {
          this.isInProgressRegister = true;
          this.loginService.checkRegistartion(this.OnlineUserRegistration).subscribe((data) => {
            if (data != null && data.length > 0) {
              let result = data.split("$");
              this.LoginOnlineUserRegistrationID = result[1];
              if (result[0] == 'Ok') {
                this.UserEmail = this.OnlineUserRegistration.Email;
                this.UserMobile = this.OnlineUserRegistration.MobileNo;
                this.OnlineUserRegistration = {
                  'OnlineUserRegistrationID': 0,
                  'LoginMethod': 'password',
                  'FirstName': '',
                  'MiddleName': '',
                  'LastName': '',
                  'City': '',
                  'District': '',
                  'State': '',
                  'Country': '',
                  'MigratedToRegistrationID': 0,
                  'MobileNo': '',
                  'WhatsAppNo': '',
                  'UserID': '',
                  'Email': '',
                  'Password': '',
                  'ConfirmPassword': '',
                  'UserName': '',
                  'LoginPassword': '',
                  'Type': '',
                  'RememberMe': false
                };
                this.toasterService.success("Record Saved Successfully!!");
                this.ngForm.reset();
                //this.isMainScreen = true;
                this.IsRegistrationDone = true;
                this.issignin = false;
                //this.isRegistration = false;
                this.IsOTPSent = false;
                this.IsEmailVerified = false;
                this.Suggestion = [];
              }
              else {
                this.toasterService.error("Please enter valid credentials!");
              }
            }
            this.isInProgressRegister = false;
          });
        }
        else {
          this.toasterService.warning("Please enter all details.");
          this.fieldErrors["RegisterU"] = "Please enter all details!!";
        }
      } else {
        this.toasterService.warning("Passwords do not match. Please make sure both fields contain the same password.");
        this.fieldErrors["PassMiss"] = "Passwords do not match. Please make sure both fields contain the same password!!";
      }
    }
    else {   // user Login
      if (this.OnlineUserRegistration.LoginMethod == 'otp') {
        const enteredOtp = this.Loginotp.join('');
        if (enteredOtp.length !== this.Loginotp.length) {
          this.errorMessage = 'Please enter the complete OTP.';
          return;
        }
        this.OnlineUserRegistration.LoginPassword = enteredOtp;
      }
      if (this.OnlineUserRegistration.UserName.trim() != "" && this.OnlineUserRegistration.LoginPassword.trim() != "") {
        this.isInProgress = true;
        this.loginService.checkRegistartion(this.OnlineUserRegistration).subscribe((data) => {
          if (data != "" && data != null && data != "OTP Expire" && data != "Enter Correct" && data != "Failed" && data != "UserID not found" && data != "Password not match") {
            this.authService.setToken(data);
            const tokenInfo = this.authService.getDecodedToken();
            this.globals.UserName = tokenInfo["unique_name"];
            this.LoginOnlineUserRegistrationID = tokenInfo["nameid"];
            this.MobileNo = tokenInfo["MobileNo"];
            this.globals.UserEmail = tokenInfo["Email"];
            this.getDoctorHoliday();
            this.globals.UserID = this.LoginOnlineUserRegistrationID;
            this.toasterService.success("You have been successfully logged in!");
            if (this.globals.LastVisitedComponent.includes('onlineyoga')) {
              this.router.navigate(['/session/onlineyoga']);
            }
            this.issignin = true;
            this.OnlineUserRegistration = {
              'OnlineUserRegistrationID': 0,
              'LoginMethod': this.OnlineUserRegistration.LoginMethod,
              'FirstName': '',
              'MiddleName': '',
              'LastName': '',
              'City': '',
              'District': '',
              'State': '',
              'Country': '',
              'MigratedToRegistrationID': 0,
              'MobileNo': '',
              'WhatsAppNo': '',
              'UserID': '',
              'Email': '',
              'Password': '',
              'ConfirmPassword': '',
              'UserName': '',
              'LoginPassword': '',
              'Type': '',
              'RememberMe': false
            };
            this.isMainScreen = false;
            this.checkinDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
            this.AdmissionDuration = this.minDuration;
            this.itemToEdit.OnlineUserRegistrationID = this.LoginOnlineUserRegistrationID;
            this.isLoginAvaibility = true;
            this.isInProgress = false;
            this.IsOTPSent = false;
            this.LoadGuest();
            this.GetUserDetails();
            this.GetConfigurationDetails();
            this.pageHitCount('/session/booking-login/booking-login/GuestList');
          } else if (data == "OTP Expire") {
            this.issignin = false;
            this.isInProgress = false;
            // this.IsOTPSent = false;
            this.toasterService.warning("You entered OTP get expire. Please try again !!");
          } else if (data == "Enter Correct") {
            this.issignin = false;
            this.isInProgress = false;
            // this.IsOTPSent = false;
            this.toasterService.warning("Please enter correct OTP !!");
          } else if (data == "UserID not found") {
            this.issignin = false;
            this.isInProgress = false;
            // this.IsOTPSent = false;
            this.toasterService.warning("Please enter correct User Name !!");
            document.getElementById('LoginUserName').focus();
            this.fieldErrors["LoginUserID"] = "Please enter correct User Name";
          } else if (data == "Password not match") {
            this.issignin = false;
            this.isInProgress = false;
            // this.IsOTPSent = false;
            // if (this.OnlineUserRegistration.LoginMethod == "otp") {
            //   document.getElementById('LoginUserName').focus();
            // } else {
            //   document.getElementById('LoginPassOTP').focus();
            // }
            let message = this.OnlineUserRegistration.LoginMethod == "otp" ? "Please enter correct OTP" : "Please enter correct Password";
            document.getElementById('LoginPassOTP').focus();
            this.fieldErrors["LoginPassOTP"] = message;
            this.toasterService.warning(message);
          } else {
            this.issignin = false;
            this.isInProgress = false;
            // this.IsOTPSent = false;
            this.toasterService.warning("You entered an incorrect User ID / Passowrd.Please try again or try resetting your password.");
          }
        });
      }
      else {
        this.toasterService.warning("Please enter all details.");
        // this.IsOTPSent = false;
      }
    }
  }

  hidePassword = true; // Controls password visibility

  resetForm(param) {
    this.OnlineUserRegistration.LoginMethod = param;
    this.OnlineUserRegistration.UserName = '';
    this.OnlineUserRegistration.LoginPassword = '';
    this.ngForm.reset();
  }

  togglePassword() {
    this.hidePassword = !this.hidePassword;
  }

  // Log Out User
  LogOut() {
    this.authService.logOut();
    this.ngForm.value.UserName = "";
    this.ngForm.value.LoginPassword = "";
    this.ngForm.value.FirstName = "";
    this.ngForm.value.MiddleName = "";
    this.ngForm.value.LastName = "";
    this.ngForm.value.MobileNo = "";
    this.ngForm.value.Email = "";
    this.ngForm.value.Password = "";
    this.LoginOnlineUserRegistrationID = 0;
    this.globals.UserName = '';
    this.BookingHistory = [];
    this.isBookingHistory = false;
    this.globals.UserID = 0;
    this.IsRegistrationDone = false;
    this.SelectedOnlinePatientRegistrationID = 0;
    this.SelectedClassID = 0;
    this.MobileNo = '';
    this.itemToEdit.OnlineUserRegistrationID = this.LoginOnlineUserRegistrationID;
    this.ngForm.reset();
    this.isMainScreen = true;
    this.isregister = false;
    this.isRegistration = false;
    this.isbooknow = false;
    this.issignin = false;
    this.globals.isPaymentHistory = false;
    this.isBookingQuetionary = false;
    this.router.navigate(['/session/booking/booking']);
  }

  pageHitCount(url) {
    this.itemToEditPageHit = {
      'PageUrl': url,
      'HitDate': new Date(),
      'HitCount': 1,
      'UserIP': '',
    }
    this.commonService.pageHitCount(this.itemToEditPageHit).subscribe(() => {
    });
  }

  // to show registration screen
  GetRegistartion() {
    this.ngForm.value.UserName = "";
    this.ngForm.value.LoginPassword = "";
    this.ngForm.value.FirstName = "";
    this.ngForm.value.MiddleName = "";
    this.ngForm.value.LastName = "";
    this.ngForm.value.MobileNo = "";
    this.ngForm.value.Email = "";
    this.ngForm.value.PassportNo = "";
    this.ngForm.value.ConfirmPassword = "";
    this.ngForm.value.Password = "";
    this.ngForm.value.Password = "";
    this.IsRegistrationDone = false;
    this.UserEmail = '';
    this.UserMobile = '';
    this.isMainScreen = !this.isMainScreen;
    let url = this.isMainScreen ? '/session/booking-login/booking-login' : '/session/booking-login/booking-login/register'
    this.pageHitCount(url);
    this.fieldErrors = {};
    this.showSuggestions = false;
    this.Suggestion = [];
    this.IsEmailVerified = false;
    this.usernameRules = {
      length: false,
      startWithLetter: false,
      allowedChars: false,
    };
    this.OTP = '';
    this.Loginotp = ['', '', '', ''];
    this.otp = ['', '', '', ''];
    this.ValidEmail = false;
    this.ngForm.reset();
    this.OnlineUserRegistration = {
      'OnlineUserRegistrationID': 0,
      'LoginMethod': 'password',
      'FirstName': '',
      'MiddleName': '',
      'LastName': '',
      'City': '',
      'District': '',
      'State': '',
      'Country': '',
      'MigratedToRegistrationID': 0,
      'MobileNo': '',
      'WhatsAppNo': '',
      'UserID': '',
      'Email': '',
      'Password': '',
      'ConfirmPassword': '',
      'UserName': '',
      'LoginPassword': '',
      'Type': '',
      'RememberMe': false
    };
    this.issignin = false;
    this.IsOTPSent = false;
    this.isRegistration = !this.isRegistration;
  }
  issignin = false;
  isAddbutton = false;

  GetsigninDetails(Type) {
    this.issignin = false;

    if (Type == 'signin') {
      // this.issignin = true;
    } else if (Type == 'Addbutton') {
      this.issignin = true;
    }
    else {
      this.issignin = false;
    }
  }

  itemToEdit = {
    'OnlinePatientRegistrationID': 0,
    'OnlineUserRegistrationID': 0,
    'UHID': 0,
    'PatientID': 0,
    'Prefix': '',
    'FirstName': '',
    'MiddleName': '',
    'LastName': '',
    'OnlineUserName': '',
    'GSM': '',
    'UserGSM': '',
    'WAGSM': '',
    'DateOfBirth': '',
    'Age': '',
    'Gender': '',
    'Address': '',
    'City': '',
    'State': '',
    'Country': '',
    'Nationality': '',
    'District': '',
    'AadharNo': '',
    'PassportNo': '',
    'VisaNo': '',
    'OCINo': '',
    'PinCode': '',
    'GuestEmail': '',
    'RelationWithUser': '',
    'MigratedToUHID': 0,
    'LogValue': '',
    'UserName': '',
    'PreferredLanguage': '',
    'IsAdharChange': false,
    'BlackListed': false,
    'Activate': true,
    // ── DUPLICATE PREVENTION: unique key per Save click ────────────────────
    'IdempotencyKey': '',
    // ─────────────────────────────────────────────────────────────────────
  };

  // Add new Guest
  AddNew(content) {
    this.itemToEdit = {
      'OnlinePatientRegistrationID': 0,
      'OnlineUserRegistrationID': 0,
      'UHID': 0,
      'PatientID': 0,
      'Prefix': this.configurationDetaild[0]["Prefix"],
      'FirstName': '',
      'MiddleName': '',
      'LastName': '',
      'OnlineUserName': '',
      'GSM': '',
      'UserGSM': '',
      'WAGSM': '',
      'DateOfBirth': this.datePipe.transform(this.Today, 'yyyy-MM-dd'),
      'Age': '',
      'Gender': '',
      'Address': '',
      'City': '',
      'State': '',
      'Country': '',
      'Nationality': '',
      'District': '',
      'AadharNo': '',
      'PassportNo': '',
      'VisaNo': '',
      'OCINo': '',
      'PinCode': '',
      'GuestEmail': '',
      'RelationWithUser': '',
      'MigratedToUHID': 0,
      'LogValue': '',
      'PreferredLanguage': '',
      'IsAdharChange': false,
      'UserName': this.globals.UserName,
      'BlackListed': false,
      'Activate': true,
      // ── DUPLICATE PREVENTION: reset key for fresh form ─────────────────
      'IdempotencyKey': '',
      // ──────────────────────────────────────────────────────────────────
    };
    this.GuestOTP = '';
    this.IsEmailVerified = false;
    this.TransferConfirmation = false;
    this.IsUserEmailSend = false;
    this.isValidAadhaar = true;
    this.modalService.open(content, {
      windowClass: "myCustomModalClass1", backdrop: 'static',
      size: 'lg', centered: true, keyboard: false
    });
  }

  isWAGSM = true;
  isUserWAGSM = true;
  // if check then GSM and WAGSM is same
  GetGSMasWAGSM(params, type) {
    if (type == 'Guest') {
      this.isUserWAGSM = !this.isUserWAGSM;
      if (params == true) {
        this.itemToEdit.WAGSM = this.itemToEdit.GSM;
      } else {
        this.itemToEdit.WAGSM = '';
      }
    } else {
      this.isWAGSM = !this.isWAGSM;
      if (params == true) {
        this.OnlineUserRegistration.WhatsAppNo = this.OnlineUserRegistration.MobileNo;
      } else {
        this.OnlineUserRegistration.WhatsAppNo = '';
      }
    }
  }

  // ── DUPLICATE PREVENTION: Generates a UUID v4 for each Save click ─────────
  private generateIdempotencyKey(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  // ──────────────────────────────────────────────────────────────────────────

  isInProgressGuest = false;
  // ── DUPLICATE PREVENTION: blocks double-click on Make Payment button ──────
  paymentInProgress = false;
  // ─────────────────────────────────────────────────────────────────────────
  TransferGuestNumber = '';
  TransferGuestEmail = '';
  TransferConfirmation = false;
  TransferPatientGuestID = 0;
  // Save Guest
  SaveGuest() {
    // this.IsEmailVerified &&
    if (this.itemToEdit.FirstName != '' && this.itemToEdit.LastName != '' && this.itemToEdit.Gender != '' && this.itemToEdit.Country != '' &&
      this.itemToEdit.Nationality != '' && this.itemToEdit.GSM != '' && this.itemToEdit.GuestEmail != '' &&
      ((this.itemToEdit.Nationality == 'Indian' && this.itemToEdit.AadharNo.length == 12 && this.isValidAadhaar) || (this.itemToEdit.Nationality != 'Indian' && this.itemToEdit.PassportNo != '' && (this.itemToEdit.VisaNo || this.itemToEdit.OCINo)))) { //
      // Check DOB is Current Date or not
      if (this.itemToEdit.DateOfBirth != "" && this.itemToEdit.DateOfBirth != null && this.itemToEdit.DateOfBirth != this.Today) {
        const ageData = this.calculateAge(this.itemToEdit.DateOfBirth, this.Today); // Get age details

        // Strict check: If age is 70 years and 1 day or more, don't allow saving
        if (ageData.years < 12 || (ageData.years === 12 && (ageData.months === 0 && ageData.days === 0)) || ageData.years > 75 || (ageData.years === 75 && (ageData.months > 0 || ageData.days > 0))) {
          alert("Guests must be at least 12 years old and younger than 75 years. For assistance, please contact the Nisargopchar team or email us at enquiry@nisargopacharashram.org.");
          return; // Stop execution
        }
        this.isInProgressGuest = true;
        this.itemToEdit.OnlineUserName = this.OnlineUserRegistration.MiddleName != '' || this.OnlineUserRegistration.MiddleName != null ?
          this.OnlineUserRegistration.FirstName + ' ' + this.OnlineUserRegistration.MiddleName + ' ' + this.OnlineUserRegistration.LastName :
          this.OnlineUserRegistration.FirstName + ' ' + this.OnlineUserRegistration.LastName;
        this.itemToEdit.DateOfBirth = this.datePipe.transform(this.itemToEdit.DateOfBirth, 'yyyy-MM-dd');
        this.itemToEdit.OnlineUserRegistrationID = this.LoginOnlineUserRegistrationID;
        this.itemToEdit.UserGSM = this.OnlineUserRegistration.WhatsAppNo;
        const Newvalue = 'OnlinePatientRegistrationID: ' + this.itemToEdit.OnlinePatientRegistrationID +
          ' ,OnlineUserRegistrationID: ' + this.itemToEdit.OnlineUserRegistrationID +
          ' ,FirstName: ' + this.itemToEdit.FirstName +
          ' ,MiddleName: ' + this.itemToEdit.MiddleName +
          ' ,LastName: ' + this.itemToEdit.LastName +
          ' ,DateOfBirth: ' + this.itemToEdit.DateOfBirth +
          ' ,Gender: ' + this.itemToEdit.Gender +
          ' ,Address: ' + this.itemToEdit.Address +
          ' ,WhatsAppMobile: ' + this.itemToEdit.WAGSM +
          ' ,PreferredLanguage: ' + this.itemToEdit.PreferredLanguage +
          ' ,Nationality: ' + this.itemToEdit.Nationality +
          ' ,AadharNo: ' + this.itemToEdit.AadharNo +
          ' ,PassportNo: ' + this.itemToEdit.PassportNo;
        this.itemToEdit.LogValue = "OldLogValue = " + this.OldLogValue + "NewLogValue = " + Newvalue;
        if (this.OldAdharNo != this.itemToEdit.AadharNo && this.itemToEdit.Nationality == 'Indian') {
          this.itemToEdit.IsAdharChange = true;
        } else {
          this.itemToEdit.IsAdharChange = false;
        }
        // ── DUPLICATE PREVENTION: generate a fresh UUID for every save attempt ──
        // This becomes the DB-level idempotency key. If the same UUID arrives
        // twice (network retry), INSERT IGNORE silently skips the second insert
        // and the backend returns "DuplicateRequest" so we never show a success
        // toast for a no-op.
        this.itemToEdit.IdempotencyKey = this.generateIdempotencyKey();
        // ────────────────────────────────────────────────────────────────────────
        this.bookingloginService.SaveGuest(this.itemToEdit).subscribe((data) => {
          if (data != undefined && data.length > 0) {
            if (data == "Ok") {
              this.IsEmailVerified = false;
              this.toasterService.success("Record Save Successfully!!");
              this.LoadGuest();
              // Saved Succesfully
              document.getElementById('btnClose').click(); // call close button
            } else if (data.includes("Found$")) {
              // Found with other ID
              // this.toasterService.warning('This patient/guest has already been registered in our system !!');
              const cnf = confirm("This patient/guest has already been registered. If you want to transfer patient/Guest then go ahead!!");
              if (cnf) {
                this.TransferConfirmation = true;
                this.TransferGuestNumber = data.split('$')[1];
                this.TransferGuestEmail = data.split('$')[2];
                this.TransferPatientGuestID = data.split('$')[3];
                //this.toasterService.success('Prosessing to transfer patient/Guest....');
              }
            } else if (data == "FoundSameID") {
              // Found with Same ID
              this.toasterService.warning('This patient/guest has already been registered under you with this Aadhar number !!');
            } else if (data == 'AadharFound') {
              this.fieldErrors["GuestAadhar"] = "This Aadhar Number is already registered !!";
              this.toasterService.warning('This Aadhar Number is already registered !!');
              //this.itemToEdit.AadharNo = this.OldAdharNo;
              // ── DUPLICATE PREVENTION: parallel request was blocked by IdempotencyKey ──
            } else if (data == 'DuplicateRequest') {
              // The first request already saved successfully. This is a parallel
              // duplicate that the DB (INSERT IGNORE) silently rejected.
              this.toasterService.warning('This guest was already saved. Please refresh the page to see the record.');
              // ────────────────────────────────────────────────────────────────────
            } else {
              this.toasterService.error('Something went wrong');
            }
            this.isInProgressGuest = false;
          } else {
            this.toasterService.error('Something went wrong');
            this.isInProgressGuest = false;
          }
        });
      } else {
        this.toasterService.warning("Please select date of birth !!");
        this.isInProgressGuest = false;
      }
    } else {
      this.toasterService.warning("Please enter mandatory fields with aadhar or passport No. \nIf passport then Visa or OCI !!");
    }
  }

  get maskedMobileNumber(): string {
    return this.TransferGuestNumber.replace(/\d(?=\d{4})/g, '*');
  }

  get maskedEmail(): string {
    return this.maskEmail(this.TransferGuestEmail);
  }

  maskEmail(email: string): string {
    if (!email || !email.includes('@')) return email;

    const [username, domain] = email.split('@');
    const visibleChars = Math.min(2, username.length);
    const visiblePart = username.substring(0, visibleChars);
    const maskedPart = '*'.repeat(username.length - visibleChars);

    return `${visiblePart}${maskedPart}@${domain}`;
  }

  // Transfer Patient under new user
  UpdateUserForPatient() {
    this.bookingloginService.UpdateUserForPatient(this.TransferPatientGuestID, this.OnlineUserRegistration.OnlineUserRegistrationID).subscribe(data => {
      if (data == "OK") {
        this.TransferConfirmation = false;
        document.getElementById('btnClose').click(); // call close button
        this.TransferGuestNumber = '';
        this.TransferGuestEmail = '';
        this.TransferPatientGuestID = 0;
        this.LoadGuest();
        this.toasterService.success('Guest transfer successfully!!');
      }
      else {
        this.toasterService.error('Something went wrong');
      }
    });
  }

  OldAdharNo = '';
  OldLogValue = '';
  // This method is used to get/view details of selected Guest
  ViewGuest(OnlinePatientRegistrationID, content, AadharNo, PassportNo, Nationality) {
    this.getStateList();
    this.defaultDOB = this.datePipe.transform(new Date(2000, 0, 1), 'yyyy-MM-dd');
    this.modalService.open(content, {
      windowClass: "myCustomModalClass1", backdrop: 'static',
      size: 'lg', centered: true, keyboard: false
    });
    this.bookingloginService.GuestDetail(OnlinePatientRegistrationID, false, this.LoginOnlineUserRegistrationID).subscribe(data => {
      if (data.length > 0) {
        this.itemToEdit = data[0];
        this.itemToEdit.DateOfBirth = this.datePipe.transform(this.itemToEdit.DateOfBirth, 'yyyy-MM-dd');
        this.itemToEdit.PinCode = data[0].PinCode;
        this.itemToEdit.Gender = data[0].Gender;
        this.OldAdharNo = data[0].AadharNo;
        this.itemToEdit.Activate = data[0]["Activate"] == 1 ? true : false;
        this.SetRequiredFields();
        this.ValidateAadhaar(this.itemToEdit.AadharNo);
        this.OldLogValue = "";
        this.OldLogValue = 'OnlinePatientRegistrationID: ' + this.itemToEdit.OnlinePatientRegistrationID +
          ' ,OnlineUserRegistrationID: ' + this.itemToEdit.OnlineUserRegistrationID +
          ' ,FirstName: ' + this.itemToEdit.FirstName +
          ' ,MiddleName: ' + this.itemToEdit.MiddleName +
          ' ,LastName: ' + this.itemToEdit.LastName +
          ' ,DateOfBirth: ' + this.itemToEdit.DateOfBirth +
          ' ,Gender: ' + this.itemToEdit.Gender +
          ' ,Address: ' + this.itemToEdit.Address +
          ' ,WhatsAppMobile: ' + this.itemToEdit.WAGSM +
          ' ,PreferredLanguage: ' + this.itemToEdit.PreferredLanguage +
          ' ,Nationality: ' + this.itemToEdit.Nationality +
          ' ,AadharNo: ' + this.itemToEdit.AadharNo +
          ' ,PassportNo: ' + this.itemToEdit.PassportNo + " ";
      }
      else {
        this.toasterService.error('Something went wrong');
      }
    });
  }

  // to set fields mandatory
  SetRequiredFields() {
    for (let i = 0; i < this.validations.length; i++) {
      if (this.validations[i]['IsMandatory'] == true) {
        const append = '<i class="text-danger"> *</i>';
        document.getElementById('lbl' + this.validations[i]['ControlID'])['innerHTML'] += append;
      }
    }
  }

  // to set Aadhar or Passport Mandatory on Nationality
  SetMandatoryAadharandPassport() {
    setTimeout(() => {
      const append = '<i class="text-danger"> *</i>';

      if (this.itemToEdit.Nationality === 'Indian') {
        // Remove * from Passport and add * to Aadhaar
        document.getElementById('lblPassportNo').innerHTML =
          document.getElementById('lblPassportNo').innerHTML.replace(append, '');

        if (!document.getElementById('lblAadharNo').innerHTML.includes(append)) {
          document.getElementById('lblAadharNo').innerHTML += append;
        }
      } else {
        this.isValidAadhaar = true;
        // Remove * from Aadhaar and add * to Passport
        document.getElementById('lblAadharNo').innerHTML =
          document.getElementById('lblAadharNo').innerHTML.replace(append, '');

        if (!document.getElementById('lblPassportNo').innerHTML.includes(append)) {
          document.getElementById('lblPassportNo').innerHTML += append;
        }
      }
    }, 2000);
  }

  FormChanged(): string {
    let text = "";
    text += this.validateService.ValidateControls(this.validations);
    if (text != "") {
      this.toasterService.warning(text);
    }
    return text;
  }
  // load Guest Detail data
  LoadGuest() {
    this.BookingHistory = [];
    this.isBookingHistory = false;
    this.bookingloginService.GuestDetail(0, true, this.LoginOnlineUserRegistrationID).subscribe((data) => {
      if (data.length > 0) {
        this.items = data;
      }
    })
  }

  BookingCode = '';
  //Get auto generated code for Booking Detail Code
  // GetBookingCode() {
  //   this.bookingloginService.BookingCode().subscribe((data) => {
  //     if (data != undefined && data != null) {
  //       this.BookingCode = data;
  //     }
  //   });
  // }

  // Converting Text into UpperCase
  UpperCase(str, fieldname) {
    const result = this.validateService.UpperCase(str);
    this.itemToEdit[fieldname] = result;
  }
  // trim the spaces from strings
  TrimName(str, fieldname) {
    const result = str.trim();
    this.itemToEdit[fieldname] = result;
  }

  AdmissionandPatientHistoryYear = [];
  // Get Patient Previous history sheet complited 1 year or not with latest booking AdmissionID
  CheckAdmissionandPatientHistoryYear() {
    this.bookingloginService.CheckAdmissionandPatientHistoryYear(this.SelectedOnlinePatientRegistrationID).subscribe((data) => {
      if (data != undefined && data != null) {
        this.AdmissionandPatientHistoryYear = data;
      }
    });
  }

  QuestionnaireList = [];
  IsHoldPatient = false;
  isDisabled = false;
  // Getting Applicant online admission eligibility form quetions
  GetQuestionnaire(SelectedOnlinePatientRegistrationID, param) {
    this.Questionnaire = [{
      'BookingQuestionnaireID': 0,
      'OnlinePatientRegistrationID': 0,
      'BookingID': 0,
      'QuestionnaireID': 0,
      'SelectedAnswer': '',
      'QuestionnaireDate': '',
      'PatientID': 0,
      'PatientName': '',
      'isAgeLarge': false,
      'Age': '',
      'Gender': '',
      'Mobile': '',
      'Category': '',
      'LabelName': '',
      'Question': '',
      'TextAnswer': '',
      'SelectedDate': '',
      'IsEligible': false,
    }];
    this.IsHoldPatient = false;
    this.isDisabled = false;
    this.commonService.GetQuestionnaire(SelectedOnlinePatientRegistrationID, 'Booking', 'Booking', 'English').subscribe(data => {
      if (data.length > 0 && data != null) {
        let IsEligible = data.filter(x => x['IsEligible'] == false || x['IsEligible'] == 0);
        let IsReject = data.filter(x => x['IsReject'] == true || x['IsReject'] == 1);
        let SelectedAnswer = data.filter(x => x['SelectedAnswer'] != '' || x['TextAnswer'] != '');
        const DOB = this.datePipe.transform(this.GuestQuetionaridetails[0]['DateOfBirth'], 'yyyy-MM-dd');
        const ageData = this.calculateAge(DOB, this.checkinDate); // Get age details
        // if ((ageData.years > 70 || (ageData.years === 70 && (ageData.months > 0 || ageData.days > 0)) || ageData.years > 75 || (ageData.years === 75 && (ageData.months > 0 || ageData.days > 0))) && IsReject.length > 0) {
        //   this.toasterService.warning("You are not eligible for booking due to age restrictions and missing doctor approval.");
        // } else
        if (IsEligible.length > 0 && SelectedAnswer.length > 0 && IsReject.length == 0) {
          this.isregister = true;
          this.Questionnaire = data;
          this.isDisabled = true;
          this.isBookingQuetionary = true;
          if (!param)
            alert("Information!\nWe regret to inform you, " + this.GuestName + ", that your online admission is currently on hold. Please contact us for a telephonic or online consultation, followed by confirmation of your offline booking at the Ashram.");
        } else if (IsEligible.length == 0 && SelectedAnswer.length == data.length && IsReject.length == 0) {
          this.IsHoldPatient = true;
          this.isBookingQuetionary = false;
          this.isregister = true;
          //this.CheckAvailability();
        } else {
          this.Questionnaire = data;
          this.SelectedOnlinePatientRegistrationID = SelectedOnlinePatientRegistrationID;
          this.isregister = true;
          this.isBookingQuetionary = true;
        }
      } else {
        this.toasterService.error('Something went wrong!');
      }
      this.isInProgress = false;
      // for (let i = 0; i < data.length; i++) {
      //   if (data[i]["SelectedAnswer"] != "") {
      //     this.Questionnaire[i].SelectedAnswer = data[i]["SelectedAnswer"];
      //     this.Questionnaire[i].IsEligible = data[i]["IsEligible"] == 1 ? true : false;
      //     this.Questionnaire[i].Category = data[i]["Category"];
      //     this.Questionnaire[i].LabelName = data[i]["LabelName"];
      //     this.Questionnaire[i].Question = data[i]["Question"];
      //     this.Questionnaire[i].TextAnswer = "";
      //     this.Questionnaire[i].SelectedDate = "";
      //   }
      // }
    });
  }

  isBookingQuetionary = false;
  GuestQuetionaridetails = [];

  Questionnaire = [{
    'BookingQuestionnaireID': 0,
    'OnlinePatientRegistrationID': 0,
    'BookingID': 0,
    'QuestionnaireID': 0,
    'SelectedAnswer': '',
    'QuestionnaireDate': '',
    'Age': '',
    'isAgeLarge': false,
    'PatientID': 0,
    'PatientName': '',
    'Gender': '',
    'Mobile': '',
    'Category': '',
    'LabelName': '',
    'Question': '',
    'TextAnswer': '',
    'SelectedDate': '',
    'IsEligible': false,
  }];
  saveQuestionnaireEligibility(contentDocument) {
    // if (this.Questionnaire[0].OnlinePatientRegistrationID != 0) {
    this.Questionnaire[0].PatientName = this.GuestQuetionaridetails[0]['GuestName'];
    this.Questionnaire[0].Gender = this.GuestQuetionaridetails[0]['Gender'];
    this.Questionnaire[0].Mobile = this.GuestQuetionaridetails[0]['GSM'];
    this.Questionnaire[0].Age = this.GuestQuetionaridetails[0]['Age'];
    this.Questionnaire[0].PatientID = this.GuestQuetionaridetails[0]['PatientID'];
    const DOB = this.datePipe.transform(this.GuestQuetionaridetails[0]['DateOfBirth'], 'yyyy-MM-dd');
    const ageData = this.calculateAge(DOB, this.checkinDate); // Get age details
    let ContainBlank = this.Questionnaire.filter((x) => x['SelectedAnswer'] == "");
    if (ContainBlank.length == 0) {
      let ContainYes = this.Questionnaire.filter((x) => x['SelectedAnswer'] == "true");
      // if (ageData.years > 70 || (ageData.years === 70 && (ageData.months > 0 || ageData.days > 0)) || ageData.years > 75 || (ageData.years === 75 && (ageData.months > 0 || ageData.days > 0))) {
      //   this.Questionnaire[0].isAgeLarge = true;
      //   this.saveQuestionnaire();
      //   this.SendHoldWhatsAppMessage(this.GuestQuetionaridetails[0]['GuestName'], this.GuestQuetionaridetails[0]['GSM']);
      // } else
      if (ContainYes.length > 0) {
        this.saveQuestionnaire(contentDocument);
        this.SendHoldWhatsAppMessage(this.GuestQuetionaridetails[0]['GuestName'], this.GuestQuetionaridetails[0]['GSM'], this.GuestQuetionaridetails[0]['PatientID'], this.GuestQuetionaridetails[0]['UHID']);
      } else {
        this.RoomCategory = 0;
        this.pageHitCount('/session/booking-login/booking-login/BedAvailability');
        this.isBookingQuetionary = false;
        this.isregister = true;
        //this.CheckAvailability();
      }
    } else {
      this.toasterService.warning("All questions are mandatory");
    }
    // }
  }

  SendHoldWhatsAppMessage(GuestName, GSM, PatientID, UHID) {
    if (GuestName != "" && GSM != "")
      this.bookingloginService.SendHoldWhatsAppMessage(GuestName, GSM, 2, 2, PatientID, UHID).subscribe((data) => { });
  }

  saveQuestionnaire(contentDocument) {
    if (this.Questionnaire.length > 0) {
      if (this.Questionnaire[0].OnlinePatientRegistrationID != 0) {

        this.isInProgress = true;
        this.bookingloginService.saveQuestionnaire(this.Questionnaire).subscribe((data) => {
          if (this.Questionnaire[0].isAgeLarge && data == "NO") {
            //alert("Information!\nRegret to inform you that, " + this.GuestName + " your online admission is on hold. Please contact us for a telephonic or online consultation; followed by confirmation of offline booking at Ashram.");
            alert("Information!\nWe regret to inform you, " + this.GuestName + ", that your online admission is currently on hold. Please contact us for a telephonic or online consultation, followed by confirmation of your offline booking at the Ashram.");
            // this.isBookingQuetionary = false;
            // this.isregister = false;
            this.GetQuestionnaire(this.SelectedOnlinePatientRegistrationID, true);
          } else if (data == "NO") {
            //alert("Information!\nRegret to inform you that, " + this.GuestName + " is NOT eligible for online admission. Please contact us for a telephonic or online consultation; followed by confirmation of offline booking at Ashram.");
            // this.isBookingQuetionary = false;
            // this.isregister = false;
            this.AttachDocument(contentDocument, 0);
            this.GetQuestionnaire(this.SelectedOnlinePatientRegistrationID, true);
          } else if (data == "Mandatory") {
            this.toasterService.warning("All questions are mandatory");
          }
          else if (data != "OK") {
            this.toasterService.error('Something went wrong!');
          }
          this.isInProgress = false;
        });
      } else {
        this.toasterService.warning("Please select Guest!!");
      }
    }
  }

  UserEmail = '';
  SelectedOnlinePatientRegistrationID = 0;
  GetcheckFunction(GuestName, OnlinePatientRegistrationID, AadharNo, PassportNo, Nationality) {
    this.ResheduleBookingDetails = [];
    this.IsReSchedule = false;
    this.paymentInProgress = false;
    this.ClearBedFilter();
    this.isInProgress = true;
    if (AadharNo == "" && PassportNo == "") {
      let Variable = Nationality == 'Indian' ? 'Aadhar number' : 'Passport number';
      alert("Please enter " + Variable + " before proceed!!");
      this.isInProgress = false;
    } else {
      let result = this.items.filter((x) => x["OnlinePatientRegistrationID"] == OnlinePatientRegistrationID);
      this.GuestQuetionaridetails = result;
      this.UserEmail = this.GuestQuetionaridetails[0]['Email'];
      this.SelectedOnlinePatientRegistrationID = OnlinePatientRegistrationID;
      this.GuestName = GuestName;
      //this.pageHitCount('/session/booking-login/booking-login/GuestBookingQuestionaire');
      this.GetQuestionnaire(this.SelectedOnlinePatientRegistrationID, false);

    }
  }

  rowBackgrounds: string[] = ['bg-primary', 'bg-warning', 'bg-success', 'bg-danger', 'bg-warning', 'bg-primary', 'bg-success', 'bg-warning', 'bg-danger', 'bg-success', 'bg-primary'];
  getRowBackground(index: number): string {
    return this.rowBackgrounds[index % this.rowBackgrounds.length];
  }

  isbooknow: boolean = false;
  SelectedRow = [];
  Selectedheader = [];
  SelectedAliesName = "";
  SelectedClassID = 0;
  isLoginAvaibility = false;
  TotalAmount = 0;
  isBookingHistory = false;

  // Helper function to convert string to Date object yyyy-mm-dd
  parseLocalDateString(dateStr: string): Date {
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day); // month is 0-based
  }

  // Helper function to convert string to Date object dd-mm-yyyy
  convertToDate(dateString: string): Date {
    const [day, month, year] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  Index = -1;
  IsSpin = false;
  // Get selected room class details with checking Guest age below 70 year
  GetBookNow(item: any, index: number) {
    //const checkin = new Date(this.checkinDate).getTime();
    //const allowedDate = new Date('2026-08-15').getTime();
    //const retreatName = item['Healing retreat']?.toLowerCase();
    // if (
    //   retreatName.includes('premium') &&
    //   checkin < allowedDate
    // ) {
    //   this.toasterService.warning('Premium accommodation is available only for bookings after 15th August 2026.');
    //   this.IsSpin = false;
    //   this.Index = -1;
    //   return;
    // }
    // this.checkinDate is in "YYYY-MM-DD"
    const [year, month, day] = this.checkinDate.split("-").map(Number);
    // Create date without time zone shift
    const dateObj = new Date(year, month - 1, day);
    this.IsPaymentScreen = false;
    // Format in desired style
    const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' };
    const formattedDate = dateObj.toLocaleDateString('en-GB', options);
    //alert("Your selected check-in/Admission date is " + formattedDate + ". If this is correct, please continue. If not, kindly reselect the date and category.");
    this.isChecked = false;
    this.IsSpin = true;
    this.Index = index;
    const date = this.parseLocalDateString(this.checkinDate);
    // console.log(date);
    if (this.disableSundays(date)) {
      let Eligible = false;
      //if (this.BookingID == 0)
      // Check previous booking 6 month complited or not.
      this.bookingloginService.GetBookingeligibility(this.GuestQuetionaridetails[0]['Nationality'], this.GuestQuetionaridetails[0]['AadharNo'], this.GuestQuetionaridetails[0]['PassportNo'], this.GuestQuetionaridetails[0]['PatientID']).subscribe((data) => {
        //data = false meance not eligible and data = true meance eligible.
        if (data) {
          Eligible = data;
          this.IsSpin = false;
          this.Index = -1;
        } else {
          if (this.BookingID == 0)
            alert('You can try booking after discharge !!!');
          this.IsSpin = false;
          this.Index = -1;
        }
        if (Eligible || this.BookingID != 0) {
          const DOB = this.datePipe.transform(this.items.filter(x => x['OnlinePatientRegistrationID'] == this.SelectedOnlinePatientRegistrationID)[0]['DateOfBirth'], 'yyyy-MM-dd');
          const ageData = this.calculateAge(DOB, this.checkinDate); // Get age details
          debugger
          // Strict check: If age is 70 years and 1 day or more, don't allow saving
          if (ageData.years < 12 || (ageData.years === 12 && (ageData.months === 0 && ageData.days === 0)) || ageData.years > 75 || (ageData.years === 75 && (ageData.months > 0 || ageData.days > 0))) {
            alert("Guests must be at least 12 years old and younger than 75 years. For assistance, please contact the Nisargopchar team or email us at enquiry@nisargopacharashram.org.");
            // return; // Stop execution
          } else {
            // document.getElementById("navbarSupportedContentID").click();
            if (this.isLoginAvaibility) {
              this.isbooknow = true;
              this.SelectedRow = this.tableitem.filter((x) => x['ClassID'] == item['ClassID'] && x['Rate'] == item['Rate']);
              this.SelectedClassID = item['ClassID'];
              this.tableitem = this.SelectedRow;
              this.selectedRate = this.tableitem[0]["Rate"];
              this.selectedAliesName = this.tableitem[0]["Healing retreat"];
              this.TotalAmount = this.selectedRate * (this.AdmissionDuration - 1);
              this.IsSpin = false;
              this.Index = -1;
              this.MakePayment('Payment');
              //this.pageHitCount('/session/booking-login/booking-login/AccommodationAndDateDetails');
            } else {
              this.isregister = false;
            }
            this.GetAllRegulations();
          }
        }
        this.IsSpin = false;
        this.Index = -1;
      });
    } else {
      this.toasterService.warning('This day is holiday for NCA team please select another date!');
      this.IsSpin = false;
      this.Index = -1;
    }
    // setTimeout(() => {

    // }, 100);
  }

  // SelectedButtonRow = [];
  // GetSelectedRow(item) {
  //   this.SelectedButtonRow = item;
  // }

  ClearBedFilter() {
    this.AdmissionDuration = this.minDuration;
    this.checkinDateD = new Date();
    this.checkinDate = this.datePipe.transform(this.checkinDateD, 'yyyy-MM-dd');
    this.bedData = [];
    // this.SelectedButtonRow = [];
  }

  // SaveReshedule(item: any) {
  //   this.SelectedRow = this.tableitem.filter((x) => x['ClassID'] == item['ClassID'] && x['Rate'] == item['Rate']);
  //   let FinalAmount = this.GetDeduction(this.ResheduleBookingDetails['CheckinDate'], this.Today, this.ResheduleBookingDetails['AdvanceAmount']);
  //   let conf = confirm(FinalAmount + ' - your advance payment has been deducted. To reschedule your booking, you will need to pay the remaining amount. Would you like to continue?');
  //   if (conf) {
  //     this.isbooknow = true;
  //     this.SelectedClassID = item['ClassID'];
  //     this.tableitem = this.SelectedRow;
  //     this.selectedRate = this.tableitem[0]["Rate"];
  //     this.selectedAliesName = this.tableitem[0]["Healing retreat"];
  //     this.TotalAmount = this.selectedRate * (this.AdmissionDuration - 1);
  //   }
  // }

  // getting duduction while reschdule and cancellation booking
  GetDeduction(checkinDate: string, currentDate: string, advanceAmount: number): number {
    currentDate = this.datePipe.transform(currentDate, 'dd-MM-yyyy');
    const checkInDate = this.convertToDate(checkinDate);
    const todayDate = this.convertToDate(currentDate);

    const difference = this.getDateDifference(todayDate, checkInDate);
    let deductionPercentage = 0;

    // if (difference > 15) {
    //   deductionPercentage = 0;   // No deduction
    // } else if (difference >= 8 && difference <= 14) {
    //   deductionPercentage = 10;  // 10% deduction
    // } else if (difference >= 3 && difference <= 7) {
    //   deductionPercentage = 25;  // 25% deduction
    // } else if (difference >= 1 && difference <= 2) {
    //   deductionPercentage = 50;  // 50% deduction
    // } else if (difference <= 0) {
    //   deductionPercentage = 100; // 100% deduction
    // }

    if (difference > 15) {
      deductionPercentage = 0;   // No deduction
    } else if (difference >= 7 && difference <= 14) {
      deductionPercentage = 50;  // 50% deduction
    } else if (difference >= 3 && difference <= 7) {
      deductionPercentage = 75;  // 75% deduction
    } else if (difference >= 1 && difference <= 2) {
      deductionPercentage = 90;  // 90% deduction
    } else if (difference <= 0) {
      deductionPercentage = 100; // 100% deduction
    }
    const deductedAmount = (advanceAmount * deductionPercentage) / 100;
    return deductedAmount;
  }

  // Helper function to get the difference in days between two dates
  getDateDifference(date1: Date, date2: Date): number {
    const diffTime = date2.getTime() - date1.getTime();
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  SaveUserDetails() {
    this.OnlineUserRegistration.Type = 'R';
    this.loginService.checkRegistartion(this.OnlineUserRegistration).subscribe((data) => {
      if (data == "Ok") {
        this.globals.IsUserDetailsUpdate = false;
        this.toasterService.success('Record Save Successfully!!');
        this.router.navigate(['/session/booking/booking']);
      } else {
        this.toasterService.error('Something went wrong!');
      }
    });
  }

  BookingHistory = [];
  // Get Guest all booking history
  GetBookingHistory(OnlinePatientRegistrationID, AadharNo, PassportNo, Nationality) {
    if (AadharNo == "" && PassportNo == "") {
      let Variable = Nationality == 'Indian' ? 'Aadhar number' : 'Passport number';
      alert("Please enter " + Variable + " before proceed!!");
    } else {
      this.BookingHistory = [];
      this.Historypage = 1;
      let result = this.items.filter((x) => x["OnlinePatientRegistrationID"] == OnlinePatientRegistrationID);
      this.SelectedOnlinePatientRegistrationID = OnlinePatientRegistrationID;
      this.GuestQuetionaridetails = result;
      this.GuestName = result[0]['GuestName'];
      this.UserEmail = result[0]['Email'];
      this.bookingloginService.GetBookingHistory(OnlinePatientRegistrationID, '', '').subscribe((data) => {
        this.isBookingHistory = true;
        this.BookingHistory = data;
      });
      //this.pageHitCount('/session/booking-login/booking-login/GuestBookingHistory');
    }
  }

  CancellationReason = "";
  ActiononBalance = "refund";
  DeductedAmount = 0;
  finalAmount = 0; // refund / balance
  seletedAdvanceAmount = 0;
  selectedBookingID = 0;
  seletedBookingPatientID = 0;
  GuestEmail = '';
  IsDeactivateClick = false;
  // deactivate Booking
  DeactivateBookingID(content, PatientID, BookingID, CheckinDate, AdvanceAmount, GuestEmail, BookingCode) {
    if (content != "") {
      this.GuestEmail = GuestEmail;
      this.seletedAdvanceAmount = AdvanceAmount;
      this.selectedBookingID = BookingID;
      this.seletedBookingPatientID = PatientID;
      this.DeductedAmount = this.GetDeduction(CheckinDate, this.Today, this.seletedAdvanceAmount);
      this.finalAmount = this.seletedAdvanceAmount - this.DeductedAmount;
      this.CancellationReason = "";
      this.ActiononBalance = "refund";
      this.BookingCode = BookingCode;
      this.modalService.open(content, { backdrop: 'static', size: 'md', backdropClass: 'modal-large', centered: true, keyboard: false });
    } else {
      // const conf = confirm(
      //   "Your advance payment is ₹" + this.seletedAdvanceAmount + ".\n" +
      //   "₹" + this.DeductedAmount + " will be deducted, and ₹" + this.finalAmount + " will be carried forward.\n\n" +
      //   "To reschedule, you'll need to pay the balance.\n\n" +
      //   "For a refund instead, email us at enquiry@nisargopacharashram.org with your bank details.\n\n" +
      //   "Do you want to proceed?"
      // );

      const conf = confirm(
        "Your advance payment is ₹" + this.seletedAdvanceAmount + ".\n" +
        "₹" + this.DeductedAmount + " will be deducted, and ₹" + this.finalAmount + " will be refunded.\n\n" +
        "Please email us at enquiry@nisargopacharashram.org with your bank details.\n\n" +
        "Do you want to proceed?"
      );
      if (conf) {
        this.IsDeactivateClick = true;
        if (this.CancellationReason != "" && this.ActiononBalance != "") {
          this.bookingloginService.DeactivateBookingID(this.seletedBookingPatientID, this.selectedBookingID, this.SelectedOnlinePatientRegistrationID,
            this.DeductedAmount, this.finalAmount, this.seletedAdvanceAmount, this.globals.UserName, this.CancellationReason, this.ActiononBalance, this.GuestEmail, 0, this.BookingCode).subscribe((data) => {
              if (data == "Ok") {
                this.GetBookingHistory(this.SelectedOnlinePatientRegistrationID, 'Other', '1234', '1234');
                this.toasterService.success('Record Deactivated Successfully!!');
                document.getElementById("DeactivateBookingID").click();
              } else {
                this.toasterService.error('Something went wrong!');
              }
              this.IsDeactivateClick = false;
            });
        } else {
          this.toasterService.warning("Please select cancellation reason / Action on Balance");
          this.IsDeactivateClick = false;
        }
      }
    }
  }

  tableitem = [];
  checkinDate = '';
  checkinDateD = new Date();
  checkoutDate = '';
  BookingCount = 0;
  Nobedforthisrange = false;
  RoomCategory = 0;
  RoomCategoryList = [];
  // Check bed availability from check in date on duration with get class, rate and count of Bed
  CheckAvailability() {
    this.GetAllRegulations();
    this.IsSpin = false;
    this.Index = -1;
    this.RoomCategory = +this.RoomCategory;
    this.itemToEditBooking.IsRoomBook = false;
    // this.SelectedButtonRow = [];
    this.RecommendedBookingDatesList = [];
    this.bedData = [];
    this.errorMessage = '';
    this.headers = [];
    this.isBookingQuetionary = false;
    this.isregister = true;
    this.isInProgress = true;
    this.checkinDate = this.datePipe.transform(this.checkinDateD, 'yyyy-MM-dd');
    this.GetBookingCount(this.checkinDate);
    setTimeout(() => {
      this.isInProgress = true;
      this.bookingService.getDailyBedCount(this.checkinDate, this.AdmissionDuration).subscribe((data) => {
        if (data && data.length > 0) {
          // Check if the response contains an error message
          if (data[0].Status === 'Error' || this.BookingCount == -1) {
            this.errorMessage = 'The database server is currently unreachable.Please try again later.'; // Show error message
            this.tableitem = [];
            this.bedData = [];
            this.headers = [];
            this.RoomCategoryList = [];
          } else {
            this.tableitem = data;
            this.bedData = [];
            this.errorMessage = '';
            this.headers = [];
            this.RoomCategoryList = data;
            // Dynamically populate headers excluding "ClassID" and "BedCount"
            data.forEach((value) => {
              Object.keys(value).forEach((key) => {
                if (key !== 'ClassID' && key !== 'BedCount' && key !== 'ImgURL' && !this.headers.includes(key)) {
                  this.headers.push(key);
                }
              });
            });
            data.forEach((value) => {
              let result = this.noVacancyMessage(value);
              if (result == '') {
                // if (value['Healing retreat'] == "DELUXE TWIN WITH AC" && this.checkinDate > '2026-08-14') {
                //   value['Rate'] = '1800.00';
                // }
                // if (value['Healing retreat'] == "SUPER DELUXE TWIN WITH AC" && this.checkinDate > '2026-08-14') {
                //   value['Rate'] = '2000.00';
                // }
                if (this.RoomCategory != 0 && value['ClassID'] == this.RoomCategory) {
                  this.bedData.push(value);
                } else if (this.RoomCategory == 0) {
                  this.bedData.push(value);
                }
              } else if (result == 'Total number of booking for this date is full. please book from another date!') {
                this.errorMessage = 'Total number of booking for this date is full. please book from another date!';
                return;
              }
            });
            this.RoomCategory = 0;
            if (this.bedData.length == 0) {
              this.Nobedforthisrange = true;
              this.errorMessage = 'No bed available for this range of data. please book for another date!';
            }
          }
        } else {
          this.errorMessage = "No data available.";
        }
        this.isInProgress = false;
      }, (error) => {
        this.errorMessage = "Failed to fetch data. Please check your connection and try again.";
        this.isInProgress = false;
      });
      const checkoutDate = this.parseLocalDateString(this.checkinDate);
      checkoutDate.setDate(checkoutDate.getDate() + (this.AdmissionDuration - 1));
      this.checkoutDate = this.datePipe.transform(checkoutDate, 'yyyy-MM-dd');
    }, 100);
    this.isInProgress = false;
  }

  GetlowestNumber(item): number {
    let lowestValue: number | null = null;
    lowestValue = this.getLowestDateValue(item);
    return lowestValue;
  }

  getLowestDateValue(data: any): number {
    const datePattern = /^\w{3}, \d{2}-\d{2}-\d{4}$/;
    const dateValues = Object.entries(data)
      .filter(([key, _]) => datePattern.test(key))
      .map(([_, value]) => Number(value));
    return Math.min(...dateValues);
  }

  RecommendedBookingDatesList = [];
  // Get Recommended +/- 10 Booking Dates for selected class
  GetRecommendedBookingDates(ClassID) {
    this.isInProgress = true;
    this.checkinDate = this.datePipe.transform(this.checkinDateD, 'yyyy-MM-dd');
    this.bookingloginService.GetRecommendedBookingDates(this.checkinDate, this.AdmissionDuration, ClassID, this.RoomCategoryName).subscribe((data) => {
      if (data.length > 0) {
        this.RecommendedBookingDatesList = data;
      }
      this.isInProgress = false;
    });
  }

  RoomCategoryName: string = '';

  onRoomCategoryChange(event) {
    console.log(event);
    const selectedIndex = event.target.selectedIndex;
    const selectedOption = event.target.options[selectedIndex];

    this.RoomCategoryName = selectedOption.getAttribute('data-name') || 'All';

    //console.log('Selected ID:', this.RoomCategory);
    //console.log('Selected Name:', this.RoomCategoryName);
  }

  GetRecommendedDateBooking(item) {
    this.checkinDate = this.datePipe.transform(item['StartDate'], 'yyyy-MM-dd');
    let date = this.disabledDates.filter(x => x['HolidayDate1'] == this.checkinDate);
    if (date.length <= 0) {
      this.bookingService.getDailyBedCount(this.checkinDate, this.AdmissionDuration).subscribe((data) => {
        if (data && data.length > 0) {
          // Check if the response contains an error message
          if (data[0].Status === 'Error' || this.BookingCount == -1) {
            this.errorMessage = 'The database server is currently unreachable.Please try again later.'; // Show error message
            this.tableitem = [];
            this.bedData = [];
            this.headers = [];
            this.RoomCategoryList = [];
          } else {
            this.tableitem = data;
            this.bedData = [];
            this.errorMessage = '';
            this.headers = [];
            this.RoomCategoryList = data;
            // Dynamically populate headers excluding "ClassID" and "BedCount"
            data.forEach((value) => {
              Object.keys(value).forEach((key) => {
                if (key !== 'ClassID' && key !== 'BedCount' && key !== 'ImgURL' && !this.headers.includes(key)) {
                  this.headers.push(key);
                }
              });
            });
            data.forEach((value) => {
              let result = this.noVacancyMessage(value);
              if (result == '') {
                if (this.RoomCategory != 0 && value['ClassID'] == this.RoomCategory) {
                  this.bedData.push(value);
                } else if (this.RoomCategory == 0) {
                  this.bedData.push(value);
                }
              } else if (result == 'Total number of booking for this date is full. please book from another date!') {
                this.errorMessage = 'Total number of booking for this date is full. please book from another date!';
                return;
              }
            });
            this.RoomCategory = 0;
            if (this.bedData.length == 0) {
              this.Nobedforthisrange = true;
              this.errorMessage = 'No bed available for this range of data. please book for another date!';
            }
          }
        } else {
          this.errorMessage = "No data available.";
        }
        const checkoutDate = this.parseLocalDateString(this.checkinDate);
        checkoutDate.setDate(checkoutDate.getDate() + (this.AdmissionDuration - 1));
        this.checkoutDate = this.datePipe.transform(checkoutDate, 'yyyy-MM-dd');
        this.GetBookNow(item, 0);
      }, (error) => {
        this.errorMessage = "Failed to fetch data. Please check your connection and try again.";
      });
    } else {
      this.toasterService.warning("NCA team has holiday on this date. Please select other date!!");
    }
  }

  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

  scrollLeft() {
    this.scrollContainer.nativeElement.scrollBy({
      left: -200, // move left by 200px
      behavior: 'smooth'
    });
  }

  scrollRight() {
    this.scrollContainer.nativeElement.scrollBy({
      left: 200, // move right by 200px
      behavior: 'smooth'
    });
  }

  // Get total count of admission on selected checkin date
  GetBookingCount(checkinDate) {
    if (checkinDate && checkinDate !== 'null' && checkinDate !== '') {
      this.bookingService.GetBookingCount(checkinDate).subscribe((data) => {
        this.BookingCount = data;
      });
    }
  }

  isFinalPayment = false;
  PreviousBalancewithBookingID = [];
  MakePayment(pram) {
    this.itemToEditBooking.ThirdpartyPaymentID = '';
    this.itemToEditBooking.ThirdpartyPaymentOrderID = '';
    this.PreviousBalancewithBookingID = [];
    if (pram == 'Payment') {
      // Get Previous Balance with BookingID
      this.bookingloginService.GetPreviousBalancewithBookingID(this.SelectedOnlinePatientRegistrationID).subscribe((data) => {
        if (data.length > 0) {
          this.PreviousBalancewithBookingID = data;
        }
      });
      // this.isbooknow = false;
      //this.isFinalPayment = true;
      this.pageHitCount('/session/booking-login/booking-login/FinalPayment');
    } else {
      // this.isbooknow = true;
      // this.isFinalPayment = false;
    }
  }

  bedData: any[] = [];
  // Check no of vacancy in selected date range
  hasAnyAvailability(item: any): boolean {
    if (this.BookingCount >= 40) {
      return false;
    } else {
      // Filter out headers that are not day columns.
      const dayHeaders = this.headers.filter(
        key => key !== 'Healing retreat' && key !== 'Rate' && key !== 'ImgURL'
      );

      // Return true only if every day has an availability greater than 0.
      return dayHeaders.every(key => item[key] > 0);
    }
  }

  // show massage for how many days no vacancy out of days
  noVacancyMessage(item: any): string {
    if (this.BookingCount >= 40) {
      return `Total number of booking for this date is full. please book from another date!`;
    } else {
      // 1. Identify which headers are "days" (exclude 'Healing retreat' and 'Rate')
      const dayHeaders = this.headers.filter(
        (key) => key !== 'Healing retreat' && key !== 'Rate' && key !== 'ImgURL'
      );

      // 2. Count how many of those days are 0
      const totalDays = dayHeaders.length;
      const noVacancyCount = dayHeaders.filter((key) => item[key] <= 0).length;

      // 3. Build the message
      //    Example: "No vacancy on 4 out of 7 days."
      if (noVacancyCount === 0) {
        // If all days > 0
        return ``;
      } else if (noVacancyCount === totalDays) {
        // If all days are zero
        return `No vacancy on all ${totalDays} days.`;
      } else {
        // Mixed scenario
        return `No vacancy on ${noVacancyCount} out of ${totalDays} days.`;
      }
    }
  }

  section: string = '';
  ngOnInit(): void {
    this.ngForm = this.formBuilder.group({
      UserName: ['', Validators.required],
      LoginPassword: ['', Validators.required],
      FirstName: ['', Validators.required],
      MiddleName: [''],
      LastName: ['', Validators.required],
      PassportNo: ['', Validators.required],
      ConfirmPassword: ['', Validators.required],
      MobileNo: ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
      Email: ['', [Validators.required, Validators.email]],
      Password: ['', Validators.required]
    });

    this.route.url.subscribe(() => {
      this.route.firstChild?.data.subscribe(data => {
        if (data['section']) {
          this.section = data['section'];
        }
        if (this.section == 'UserDetails') {
          this.globals.IsUserDetailsUpdate = true;
          this.IsUserDetailsType = 'route';
          this.GetUserDetails();
        } else {
          this.globals.IsUserDetailsUpdate = false;
        }
      });
    });
    this.GetComponentID();
    // this.GetCheckUserTokenValidOrNot();
  }

  GetRateChart(contentTariff) {
    this.modalService.open(contentTariff, { backdrop: 'static', size: 'lg', centered: true, keyboard: false });
  }

  ValidEmail = false;
  UpdateEmail = true;
  validateEmail(email) {
    this.UpdateEmail = false;
    this.ValidEmail = this.validateService.validateEmail(email);
    this.UpdateEmail = this.ValidEmail;
    return this.ValidEmail;
  }

  isInProgressOTP = false;
  // this function is used to send OTP on email for given userID/email/Password (Login with OTP)
  SendOTPForLoginWithOTP(UserName) {
    if (UserName.trim() != "") // if usernname  is blank
    {
      this.isInProgressOTP = true;
      this.bookingloginService.SendOTPForLoginWithOTP(UserName).subscribe((data) => {
        if (data != undefined && data != null) {
          if (data.includes("OTP has been sent successfully")) {
            this.toasterService.success(data);
            this.startResendTimer();
            this.IsOTPSent = true;  // if otp is sent on email set this variable to true
          }
          else {
            this.toasterService.error(data);
            this.IsOTPSent = false; // if otp is not sent on email set this variable to false
            document.getElementById('LoginUserName').focus();
            this.fieldErrors["LoginUserID"] = "Please enter correct User Name";
          }
        }
        this.isInProgressOTP = false;
      });
    }
    else {
      this.toasterService.warning("Please enter all details.");
    }
  }

  // Getting Checked Is User Token Same Or Not
  GetCheckUserTokenValidOrNot() {
    this.commonService.GetCheckUserTokenValidOrNot().subscribe((result) => {
      if (result) {
        //   if (document.querySelector('#sideNavMenu > aside').classList.contains("ng-sidebar--opened")) {
        //     document.getElementById("toggleButton").click();
        //   }
        // Getting Token Expires Or Not
        const tokenExpires = this.authService.isTokenExpired();
        if (tokenExpires) {
          // Token Expires
          // Getting New Token
          this.GetRefreshToken();
          // Getting Checked Is User Token Same Or Not
          this.GetCheckUserTokenValidOrNot();
        } else {
          // Getting Token Expires Or Not
          // Token Is Valid
          this.GetComponentID();
        }
      } else {
        // Token is not same so loggin out user
        this.authService.logOut();
      }
    });
  }

  // Getting Refresh Token
  GetRefreshToken(): void {
    this.authService.getRefreshToken().subscribe((data) => {
      if (data != null || data != "") {
        this.authService.setToken(data);
      } else {
        this.authService.logOut();
      }
    });
  }

  // Show Back button
  GetBack() {
    if (this.IsUserDetailsType == 'click' && this.globals.IsUserDetailsUpdate) {
      this.globals.IsUserDetailsUpdate = false;
      this.IsUserDetailsType = '';
      this.section = 'booking-login-register';
      this.LoadGuest();
    } else {
      // Hide Booking History
      if (this.isBookingHistory) {
        this.BookingHistory = [];
        this.Historypage = 1;
        this.LoadGuest();
        this.isBookingHistory = false;
      }
      // Hide Patient History Sheet and show Booking History in Booking History Menue
      else if (this.IsPatientHistorySheet && this.BookingHistory.length > 0) {
        this.IsPatientHistorySheet = false;
        this.isBookingHistory = true;
      }
      // Hide Booking Quetionary and show Guest list
      else if (this.isBookingQuetionary) {
        this.isBookingQuetionary = false;
        this.isregister = false;
      }
      // Hide Bed Availability and show Booking Quetionary
      else if (this.isregister && !this.isbooknow && this.ResheduleBookingDetails && this.ResheduleBookingDetails['BookingID'] == undefined && !this.IsHoldPatient) {
        this.isregister = false;
        this.isBookingQuetionary = true;
        this.RoomCategory = 0;
        // Hide Bed Availability and show Guest List for doctor aprovel patient
      } else if (this.isregister && !this.isbooknow && this.ResheduleBookingDetails && this.ResheduleBookingDetails['BookingID'] == undefined && this.IsHoldPatient) {
        this.isregister = false;
        this.isBookingQuetionary = false;
        this.RoomCategory = 0;
      }
      // Hide Reschedule and show Booking History
      else if (this.isregister && !this.isbooknow && (this.ResheduleBookingDetails && this.ResheduleBookingDetails['BookingID'] != undefined && this.ResheduleBookingDetails['BookingID'] != 0)) {
        this.isregister = false;
        this.isBookingHistory = true;
      }
      // Hide after Bed Selection screen and show Bed Availability
      else if (this.isbooknow) {
        //this.CheckAvailability();
        this.isBookingQuetionary = false;
        this.isregister = true;
        this.isbooknow = false;
        this.isregister = true;
        this.RoomCategory = 0;
      }
      // Hide payment History
      else if (this.globals.isPaymentHistory && this.globals.UserName != "" && !this.globals.isPaymentDetails) {
        this.globals.isPaymentHistory = false;
        this.issignin = true;
      }
      // Hide payment details and show
      else if (this.globals.isPaymentHistory && this.globals.UserName != "" && this.globals.isPaymentDetails) {
        this.globals.isPaymentHistory = true;
        this.issignin = true;
        this.globals.isPaymentDetails = false;
      }
      else {
        this.isMainScreen = true;
        this.issignin = false;
        this.isRegistration = false;
      }
    }
  }

  disableSundays = (d: Date | null): boolean => {
    if (!d) return false;

    const date = d;
    const day = date.getDay();

    // Format selected date to 'yyyy-MM-dd' (local time)
    const dateString = date.toLocaleDateString('en-CA'); // 'yyyy-MM-dd'

    // Convert all holiday dates to 'yyyy-MM-dd' strings using local time
    const holidayDateStrings = this.disabledDates.map(item =>
      new Date(item.HolidayDate).toLocaleDateString('en-CA')
    );

    // If SelectedType is 'Bed', disable Sundays and holiday dates
    return day !== 0 && !holidayDateStrings.includes(dateString);
  };

  disableSundays1 = (d: Date | null): boolean => {
    if (!d) return false;

    // Convert to IST date string (yyyy-MM-dd)
    const dateString = this.convertToISTDateString(d);

    // Convert holiday dates to IST-safe strings
    const holidayDateStrings = this.disabledDates.map(item =>
      this.convertToISTDateString(new Date(item.HolidayDate))
    );

    const day = new Date(d).getDay();

    // Disable Sunday and holidays
    return day !== 0 && !holidayDateStrings.includes(dateString);
  };

  convertToISTDateString(date: Date): string {
    const utc = date.getTime() + date.getTimezoneOffset() * 60000;
    const IST_OFFSET = 5.5 * 60 * 60000; // IST = UTC + 5:30
    const istDate = new Date(utc + IST_OFFSET);
    return istDate.toISOString().split('T')[0]; // Gives "yyyy-MM-dd" in IST
  }

  // Function to calculate ages
  calculateAge(dob: string, currentD: string): { years: number, months: number, days: number } {
    const birthDate = new Date(dob);
    const currentDate = new Date(currentD);
    let years = currentDate.getFullYear() - birthDate.getFullYear();
    let months = currentDate.getMonth() - birthDate.getMonth();
    let days = currentDate.getDate() - birthDate.getDate();

    // Adjust if birth month/day hasn't passed yet this year
    if (days < 0) {
      months -= 1;
      const prevMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);
      days += prevMonth.getDate();
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }
    this.itemToEdit.Age = years + ' Y ' + months + ' M ' + days + ' D';
    return { years, months, days };
  }

  GetPaymentHistory(OnlinePatientRegistrationID, AadharNo, PassportNo, Nationality) {
    if (AadharNo == "" && PassportNo == "") {
      let Variable = Nationality == 'Indian' ? 'Aadhar number' : 'Passport number';
      alert("Please enter " + Variable + " before proceed!!");
    } else {
      //this.pageHitCount('/session/booking-login/booking-login/GuestPaymentHistory');
      this.globals.isPaymentHistory = true;
      this.SelectedOnlinePatientRegistrationID = OnlinePatientRegistrationID;
    }
  }

  // Activate or Deactivate Guest By Id
  ActivateDeactivateById(OnlinePatientRegistrationID, Activate, Nationality, AadharNo, PassportNo, PatientID, GuestName) {
    if (AadharNo == "" && PassportNo == "") {
      let Variable = Nationality == 'Indian' ? 'Aadhar number' : 'Passport number';
      alert("Please enter " + Variable + " before proceed!!");
    } else {
      const Status = Activate == 1 || Activate == true || Activate == 'true' ? false : true;
      this.bookingloginService.ActivateDeactivateById(OnlinePatientRegistrationID, Status, Nationality, AadharNo, PassportNo, PatientID, GuestName).subscribe((data) => {
        if (data != "") {
          if (data == "OK") {
            this.toasterService.success('Record Save Successfully!!');
            this.LoadGuest();
          } else if (data == "Found") {
            alert('Please cancel all active bookings before deactivating the guest/patient.');
          } else if (data == 'Patient Registered') {
            alert('This guest/patient is already registered under your account or another users account. Please deactivate the existing registration before proceeding with activation!!');
          } else {
            // Exception Occurred
            this.toasterService.error('Something went wrong!');
          }
        }
        else {
          // Exception Occurred
          this.toasterService.error('Something went wrong!');
        }
      });
    }
  }

  isValidAadhaar = true;
  ValidateAadhaar(aadhaarNumber): boolean {
    if (aadhaarNumber.trim() === "") {
      this.isValidAadhaar = false;
      return false;
    }
    else {
      if (!/^[2-9]\d{11}$/.test(aadhaarNumber)) // checking if aadhaar number is 12 digits and should not start with 0 and 1
      {
        this.isValidAadhaar = false;
        return false;
      }

      // 2. Reject all same digits (like 999999999999)
      if (/^(\d)\1{11}$/.test(aadhaarNumber)) {
        this.isValidAadhaar = false;
        return false;
      }

      //calling function to check VerhoeffAlgorithm
      this.isValidAadhaar = VerhoeffAlgorithm.validateVerhoeff(aadhaarNumber);
      return this.isValidAadhaar;
    }
  }

  isValidPassport = true;
  validatePassport(passport: string): boolean {
    if (!passport) return false;

    passport = passport.trim();

    const regex = /^[A-Za-z0-9]{6,12}$/;
    this.isValidPassport = regex.test(passport);
    return regex.test(passport);
  }

  // Key = control name, Value = error message
  fieldErrors: { [key: string]: string } = {};
  IsUserEmailSend = false;
  Suggestion = [];
  // VerifyUserEmail is used to send a OTP into your mail to verify user Email.
  VerifyUserEmail(param) {
    if (((this.OnlineUserRegistration.Email != undefined && this.OnlineUserRegistration.Email != null && this.OnlineUserRegistration.Email != '')) ||
      (this.itemToEdit.GuestEmail != undefined && this.itemToEdit.GuestEmail != null && this.itemToEdit.GuestEmail != '')
    ) {
      if (this.OnlineUserRegistration.MobileNo != undefined && this.OnlineUserRegistration.MobileNo != null && this.OnlineUserRegistration.MobileNo != "") {
        // if (this.FinalvalidateUserName(this.OnlineUserRegistration.UserID)) {

        let parts: string[] = [];
        parts.push(this.OnlineUserRegistration.Email);

        if (this.OnlineUserRegistration.FirstName?.trim()) {
          parts.push(this.OnlineUserRegistration.FirstName.trim());
        }

        if (this.OnlineUserRegistration.LastName?.trim()) {
          parts.push(this.OnlineUserRegistration.LastName.trim());
        }

        let EmailWithName = parts.join('*');

        const Email = param == 'GuestVerify' ? this.TransferGuestEmail : param == 'Verify' ? EmailWithName : this.OnlineUserRegistration.Email;
        const MobileNo = param == 'GuestVerify' ? this.TransferGuestNumber : this.OnlineUserRegistration.MobileNo;
        this.isInProgress = true;
        // this.UserEmail = email;
        this.otp = ['', '', '', '']; // Reset OTP input
        this.loginService.ForgetPassword(Email, this.OnlineUserRegistration.UserID, param, MobileNo).subscribe((data) => {
          debugger
          if (data.toString().includes('successfully')) {
            this.IsOTPSent = true;
            this.IsUserEmailSend = true;
            if (this.ResendCount == 0) {
              this.toasterService.success(data.toString());
              this.startResendTimer();
            } else {
              this.toasterService.success("A new OTP has been sent to your email. The previous OTP is no longer valid.");
            }
          } else if (data.toString().includes('already been registered')) {
            this.IsOTPSent = false;
            if (data.toString().includes('!!EMAIL')) {
              this.toasterService.warning("This Email has already been registered. Please try with another!!");
              this.fieldErrors["Email"] = "This Email has already been registered. Please try with another!!";
              document.getElementById('UserREmail').focus();
            } else if (data.toString().includes('!!MobileNumber')) {
              this.toasterService.warning("This Mobile No has already been registered. Please try with another!!");
              this.fieldErrors["Mobile"] = "This Mobile No has already been registered. Please try with another!!";
              document.getElementById('mobileNo').focus();
            } else if (data.toString().includes('!!USERNAME')) {
              debugger
              let Result = data.toString().split("!!USERNAME$");
              this.Suggestion = [];
              this.Suggestion = Result[1].toString().split("$");
              this.showSuggestions = true;
              document.getElementById('UserNameRegister').focus();
              this.toasterService.warning("This UserName has already been registered. Please try with another!!");
              this.fieldErrors["UserID"] = "This UserName has already been registered. Please try with another!!";
            }
          } else if (data.toString().includes('not registered')) {
            this.IsOTPSent = false;
            this.toasterService.warning(data.toString());
            this.fieldErrors["Email"] = data.toString();
          }
          else {
            this.IsOTPSent = false;
            this.toasterService.error(data.toString());
          }
          this.isInProgress = false;
        });
        // } else {
        //   this.toasterService.warning("Please enter correct user name !!");
        //   this.fieldErrors["UserID"] = "Please enter correct user name !!";
        // }
      } else {
        this.toasterService.warning("Please Enter Mobile Number !!");
        this.fieldErrors["Mobile"] = "Please Enter Mobile Number !!";
      }
    } else {
      this.toasterService.warning("Please Enter Email ID !!");
      this.fieldErrors["Email"] = "Please Enter Email ID !!";
    }
  }

  isInProgressMail = false;
  SendForeignerMail() {
    if (this.GuestQuetionaridetails[0].OnlinePatientRegistrationID != 0 && this.tableitem[0]["Healing retreat"] != '') {
      const OnlinePatientRegistrationID = this.GuestQuetionaridetails[0].OnlinePatientRegistrationID;
      const GuestName = this.GuestQuetionaridetails[0].GuestName;
      const Nationality = this.GuestQuetionaridetails[0].Nationality;
      const PassportNo = this.GuestQuetionaridetails[0].PassportNo;
      const GuestEmail = this.GuestQuetionaridetails[0].GuestEmail;
      const Accomodation = this.tableitem[0]["Healing retreat"];
      const checkinDate = this.datePipe.transform(this.checkinDate, 'dd-MMM-yyyy');
      const OutDate = this.parseLocalDateString(this.checkinDate);
      OutDate.setDate(OutDate.getDate() + (this.AdmissionDuration - 1));
      const checkOutDate = this.datePipe.transform(OutDate, 'dd-MMM-yyyy');
      const AdmissionDuration = this.AdmissionDuration;
      this.isInProgressMail = true;
      this.loginService.SendForeignerMail(OnlinePatientRegistrationID, GuestName, Nationality, PassportNo, Accomodation, checkinDate, AdmissionDuration, checkOutDate, GuestEmail).subscribe((data) => {
        debugger
        if (data == 'successfully') {
          this.toasterService.success("Mail Send successfully !!");
          this.isbooknow = false;
          this.isregister = false;
          this.RoomCategory = 0;
          this.isInProgressMail = false;
          // !isBookingQuetionary &&
          // !IsPatientHistorySheet &&
          // !globals.IsUserDetailsUpdate
        } else {
          this.isInProgressMail = false;
          this.toasterService.error(data.toString());
        }
        this.isInProgressMail = false;
      });
    }
  }

  showSuggestions = false;

  selectSuggestion(s: string) {
    this.OnlineUserRegistration.UserID = s;
    this.clearFieldError('UserID');
    this.Suggestion = [];
    this.showSuggestions = false;
  }

  hideSuggestions() {
    // Small timeout to allow click selection before hiding
    setTimeout(() => {
      this.showSuggestions = false;
    }, 150);
  }

  clearFieldError(field: string) {
    if (field === '' || field == null) {
      // Clear all fields
      Object.keys(this.fieldErrors).forEach(key => {
        this.fieldErrors[key] = '';
      });
    } else if (this.fieldErrors[field]) {
      // Clear specific field
      this.fieldErrors[field] = '';
    }
  }

  // this function is used to verify OTP send on email id
  VerifyOTP(UserName, OTP, param) {
    if (param == 'Verify') {
      const enteredOtp = this.otp.join('');
      if (enteredOtp.length !== this.otp.length) {
        this.errorMessage = 'Please enter the complete OTP.';
        return;
      }
      OTP = enteredOtp;
      this.OTP = enteredOtp;
    }
    if (UserName.trim() != "" && OTP.trim() != "") {
      this.loginService.verifyOtp(UserName, OTP, param).subscribe(data => {
        if (data != null && data != undefined) {
          if (data === 'OK') {
            this.IsEmailVerified = true;
            this.IsUserEmailSend = false;
            //this.IsOTPSent = false;
            this.toasterService.success("Email ID verified successfully.");
            if (param == 'GuestVerify') {
              this.UpdateUserForPatient();
            }
          }
          else {
            this.toasterService.warning("" + data);
            this.IsEmailVerified = false;
            this.fieldErrors["vOTP"] = "Please enter correct OTP!!";
            document.getElementById('vOTP').focus();
            // this.IsOTPSent = true;
          }
        }
      });
    }
    else {
      this.toasterService.warning("Email ID or OTP can't be blank.");
      this.fieldErrors["VerifyOTP"] = "Email ID or OTP can't be blank!!";
    }
  }

  startResendTimer() {
    this.isResendDisabled = true;
    this.countdown = 60;
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.isResendDisabled = false;
        clearInterval(this.timer);
      }
    }, 1000);
  }

  // Resend OTP 1 time
  resendOtp(param): void {
    this.toasterService.info('Resending OTP... Please check your email.');
    this.errorMessage = '';
    this.ResendCount = 1;
    this.otp = ['', '', '', '']; // Reset OTP input
    this.isResendUsed = true;
    if (param == 'LoginWthOTP') {
      this.IsOTPSent = false;
      this.SendOTPForLoginWithOTP(this.OnlineUserRegistration.UserName);
    } else {
      this.VerifyUserEmail(param);
    }
  }


  username: string = '';
  isUsernameValid: boolean = false;
  usernameRules = {
    length: false,
    startWithLetter: false,
    allowedChars: false,
  };

  validateUsername(value: string) {
    const trimmed = value.trim();
    this.usernameRules.length = trimmed.length >= 3 && trimmed.length <= 20;
    this.usernameRules.startWithLetter = /^[a-zA-Z]/.test(trimmed);
    this.usernameRules.allowedChars = /^[a-zA-Z][a-zA-Z0-9_.]*$/.test(trimmed);
    this.isUsernameValid = Object.values(this.usernameRules).every(Boolean);
  }
  FinalvalidateUserName(UserName: string): boolean {
    const re = /^[a-zA-Z][a-zA-Z0-9_.]{2,19}$/;
    return re.test(UserName.trim());
  }

  myFiles: File[] = [];
  SelectedIndex: number = 0;
  fileToUpload: any;
  ImageListitems: string[] = [];
  SelectedImageID: number = 0;
  attachFileName: string[] = [];
  ShowCamera = false;
  videoElement: HTMLVideoElement;
  canvasElement: HTMLCanvasElement;
  photoUrl: string | null = null;
  IsPhoto = false;

  AttachDocument(contentDocument, OnlinePatientRegistrationID) {
    if (this.GuestQuetionaridetails.length <= 0 && OnlinePatientRegistrationID != 0) {
      let result = this.items.filter((x) => x["OnlinePatientRegistrationID"] == OnlinePatientRegistrationID);
      this.SelectedOnlinePatientRegistrationID = OnlinePatientRegistrationID;
      this.GuestQuetionaridetails = result;
    }
    this.GetAllFilesForPatient(this.GuestQuetionaridetails[0]['PatientID'], 2, 2);
    //this.modalService.open(contentDocument, { backdrop: "static", size: "lg", backdropClass: "modal-large", centered: true, keyboard: false });
    this.modalService.open(contentDocument, {
      windowClass: "myCustomModalClass2", backdrop: 'static',
      size: 'lg', centered: true, keyboard: false
    });
    //this.pageHitCount('/session/booking-login/booking-login/GuestAttachment');
  }

  GetUploadedprint(name, FileUploadID, path) {
    let type;
    let filename = path.trim();
    let fileExtention = filename.split('.');
    if (fileExtention.length > 0) {
      type = fileExtention[fileExtention.length - 1] == undefined ? "" : fileExtention[fileExtention.length - 1];
    }
    const FileUploadServerType = this.configurationDetaild[0]["FileUploadServerType"];
    const ClientDetails = this.configurationDetaild[0]["SFTPHost"] + "$" + this.configurationDetaild[0]["SFTPUserName"] + "$" + this.configurationDetaild[0]["SFTPPwd"] + "$" + this.configurationDetaild[0]["SFTPPort"];
    this.bookingloginService.GetAtachementFile(path, type, 2, 2, FileUploadServerType, ClientDetails)
      .subscribe(data => {
        if (data != undefined) {
          if (data == "deleted") // if file is deleted or not present at the destination path
          {
            this.toasterService.warning("Selected file is not present or deleted.");
          }
          else {   // if file present at the location then download the file
            if (type == "pdf") {   // pdf file
              let encoded: string = atob(data);
              const linkSource = 'data:application/pdf;base64,' + data;
              const downloadLink = document.createElement("a");
              const fileName = name;
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
            }
            else if (type == "xlsx") {    // excel file
              let encoded: string = atob(data);
              const linkSource = 'data:application/xlsx;base64,' + data;
              const downloadLink = document.createElement("a");
              const fileName = name;
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
            }
            else if (type == 'txt') {   // text file
              let encoded: string = atob(data);
              const blob = new Blob([encoded], { type: 'text/plain' });
              const a = document.createElement('a');
              a.setAttribute('download', name);
              a.setAttribute('href', window.URL.createObjectURL(blob));
              a.click();
            }
            else if (type == 'docx' || type == 'doc') {   // word document
              //let encoded: string = atob(data);
              const linkSource = 'data:application/docx;base64,' + data;
              const downloadLink = document.createElement("a");
              const fileName = name;
              downloadLink.href = linkSource;
              downloadLink.download = fileName;
              downloadLink.click();
            } else if (type === 'mp4' || type === 'webm' || type === 'ogg') {
              const byteCharacters = atob(data);
              const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
              const byteArray = new Uint8Array(byteNumbers);

              let mimeType = 'video/mp4';
              if (type === 'webm') mimeType = 'video/webm';
              else if (type === 'ogg') mimeType = 'video/ogg';

              const blob = new Blob([byteArray], { type: mimeType });
              const blobUrl = URL.createObjectURL(blob);

              const win = window.open('', '_blank');
              if (win) {
                win.document.write(`
                                    <html>
                                      <head><title>${name}</title></head>
                                      <body style="margin:0; background-color:#000;">
                                        <video controls autoplay style="width:100vw; height:100vh; object-fit:contain;">
                                          <source src="${blobUrl}" type="${mimeType}">
                                          Your browser does not support the video tag.
                                        </video>
                                      </body>
                                    </html>
                                  `);
                win.document.close();
              }
            } else {
              const imageSrc = "data:image/" + type + ";base64," + data;
              const win = window.open('', '_blank');
              if (win) {
                win.document.write(`
                                    <html>
                                      <head><title>${name}</title></head>
                                      <body style="margin:0; display:flex; align-items:center; justify-content:center; background-color:#000;">
                                        <img src="${imageSrc}" style="max-width:100vw; max-height:100vh; object-fit:contain;" />
                                      </body>
                                    </html>
                                  `);
                win.document.close();
              }

            }
          }

        }
      });
  }

  onFileChange(event: any) {
    for (var i = 0; i < event.target.files.length; i++) {
      const file = event.target.files[i];
      this.myFiles.push(file); // Store file object
      this.attachFileName.push(file.name); // Store file name

      // this.itemToEditImage.AtachDoc[this.SelectedIndex] = {
      //   UploadedName: file.name,
      //   FileName: file.name,
      //   FileIndex: this.myFiles.length - 1,
      //   IsFileSelected: true,
      // };

      this.itemToEditImage.AtachDoc[this.SelectedIndex].UploadedName = event.target.files[i].name;
      this.itemToEditImage.AtachDoc[this.SelectedIndex].FileName = this.itemToEditImage.AtachDoc[this.SelectedIndex].UploadedName;
      this.itemToEditImage.AtachDoc[this.SelectedIndex].FileIndex = this.myFiles.length - 1;
      this.itemToEditImage.AtachDoc[this.SelectedIndex].IsFileSelected = true;
    }
  }

  getindex(index) {
    this.SelectedIndex = index;
  }

  // This function is used to delete file from drop box
  DeleteFile(FileUploadID, FileName, Link, index) {
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      const UserName = this.globals.UserName;
      const FilePath = Link;
      const FileUploadServerType = this.configurationDetaild[0]["FileUploadServerType"];
      const ClientDetails = this.configurationDetaild[0]["SFTPHost"] + "$" + this.configurationDetaild[0]["SFTPUserName"] + "$" + this.configurationDetaild[0]["SFTPPwd"] + "$" + this.configurationDetaild[0]["SFTPPort"];
      if (FileUploadID != 0) {
        this.bookingloginService.DeleteFileFromCloud(FilePath, FileUploadID, UserName, FileName, 2, 2, FileUploadServerType, ClientDetails).subscribe(data => {
          if (data == "ok") {
            this.GetAllFilesForPatient(this.GuestQuetionaridetails[0]['PatientID'], 2, 2);
            this.toasterService.success("File deleted successfully.");
          } else if (data == "deleted") {
            this.GetAllFilesForPatient(this.GuestQuetionaridetails[0]['PatientID'], 2, 2);
            this.toasterService.warning("Selected file is not present or already deleted.");
          }
          else {
            this.toasterService.error("Something went wrong");
          }
        });
      } else {
        this.myFiles.splice(this.itemToEditImage.AtachDoc[index].FileIndex, 1);
        this.attachFileName.splice(this.itemToEditImage.AtachDoc[index].FileIndex, 1);
        this.itemToEditImage.AtachDoc.splice(index, 1);
      }

    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.DeleteFile(FileUploadID, FileName, Link, index);
    }
  }

  // This function is used to get all image for selected patient
  GetAllFilesForPatient(PatientID, ClientID, LocationID) {
    const tokenExpires = this.authService.isTokenExpired();
    if (!tokenExpires) {
      this.itemToEditImage.AtachDoc = [];
      this.bookingloginService.GetAllFilesForPatient(PatientID, ClientID, LocationID, this.SelectedOnlinePatientRegistrationID).subscribe(data => {
        if (data !== null && data.length > 0) {
          this.ImageListitems = [];
          this.itemToEditImage.AtachDoc = data;
          let len = this.itemToEditImage.AtachDoc.length;
          this.itemToEditImage.AtachDoc[len - 1].Add = true;
        } else {
          const ToDate = this.datePipe.transform(this.Today, 'dd-MM-yyyy');
          const item = {
            "FileUploadID": 0,
            'ClientID': 2,
            'LocationID': 2,
            'PatientID': this.GuestQuetionaridetails[0]['PatientID'],
            'OnlinePatientRegistrationID': this.SelectedOnlinePatientRegistrationID,
            'LocalFolderPath': this.configurationDetaild[0]['LocalFolderPath'],
            'FileName': '',
            'UploadedName': '',
            'Remark': '',
            'AddedBy': this.globals.UserName,
            'Add': true,
            'FileIndex': 0,
            'IsFileSelected': false,
            'Date': ToDate,
            'FileUploadServerType': this.configurationDetaild[0]["FileUploadServerType"],
            'ClientDetails': this.configurationDetaild[0]["SFTPHost"] + "$" + this.configurationDetaild[0]["SFTPUserName"] + "$" + this.configurationDetaild[0]["SFTPPwd"] + "$" + this.configurationDetaild[0]["SFTPPort"],
          };
          this.itemToEditImage.AtachDoc.push(item);
        }
      });
    } else {
      // Token Expires
      // Getting New Token
      this.GetRefreshToken();
      this.GetAllFilesForPatient(PatientID, ClientID, LocationID);
    }
  }

  AddRow(index) {
    if (this.itemToEditImage.AtachDoc[index].FileName != "") {
      this.itemToEditImage.AtachDoc[index].Add = false;
      this.itemToEditImage.AtachDoc[index].IsFileSelected = true;
      const ToDate = this.datePipe.transform(this.Today, 'dd-MM-yyyy');
      const item = {
        "FileUploadID": 0,
        'ClientID': 2,
        'LocationID': 2,
        'PatientID': this.GuestQuetionaridetails[0]['PatientID'],
        'OnlinePatientRegistrationID': this.SelectedOnlinePatientRegistrationID,
        'LocalFolderPath': this.configurationDetaild[0]['LocalFolderPath'],
        'FileName': '',
        'UploadedName': '',
        'Remark': '',
        'AddedBy': this.globals.UserName,
        'Add': true,
        'FileIndex': 0,
        'IsFileSelected': false,
        'Date': ToDate,
        'Date1': "",
        'FileUploadServerType': this.configurationDetaild[0]["FileUploadServerType"],
        'ClientDetails': this.configurationDetaild[0]["SFTPHost"] + "$" + this.configurationDetaild[0]["SFTPUserName"] + "$" + this.configurationDetaild[0]["SFTPPwd"] + "$" + this.configurationDetaild[0]["SFTPPort"],
      };
      this.itemToEditImage.AtachDoc.push(item);
    } else {
      this.toasterService.warning("Please select file name !!!!");
    }
  }

  GetSelectedPatientDetails(PatientID) {
    // this.commonService.GetPatientData(PatientID, 2, 2).subscribe(data => {
    //   if (data != undefined && data != null) {
    //     this.items = data;
    //   }
    this.GetAllFilesForPatient(this.GuestQuetionaridetails[0]['PatientID'], 2, 2); // get all files attached for that patient
    // });
  }

  // 🟢 Uploading Files (Both Selected & Captured)
  UploadFile() {
    const tokenExpires = this.authService.isTokenExpired();
    let result = "";
    let AddedNewFile = false;

    if (!tokenExpires) {
      const LocalFolderPath = this.configurationDetaild[0]['LocalFolderPath'];
      if (LocalFolderPath != '') {
        const formData = new FormData();
        this.itemToEditImage.OnlinePatientRegistrationID = this.SelectedOnlinePatientRegistrationID;
        // Append all selected & captured files
        for (var i = 0; i < this.myFiles.length; i++) {
          formData.append("file[]", this.myFiles[i]); // Now works for both
          AddedNewFile = true;
        }

        for (var cnt = 0; cnt < this.itemToEditImage.AtachDoc.length; cnt++) {
          if (this.itemToEditImage.AtachDoc[cnt].FileUploadID == 0) {
            this.itemToEditImage.AtachDoc[cnt].PatientID = this.GuestQuetionaridetails[0]['PatientID'];
            this.itemToEditImage.AtachDoc[cnt].OnlinePatientRegistrationID = this.SelectedOnlinePatientRegistrationID;
            this.itemToEditImage.AtachDoc[cnt].AddedBy = this.globals.UserName;
            this.itemToEditImage.AtachDoc[cnt].ClientID = 2;
            this.itemToEditImage.AtachDoc[cnt].LocationID = 2;
            this.itemToEditImage.AtachDoc[cnt].FileUploadServerType = this.configurationDetaild[0]["FileUploadServerType"];
            this.itemToEditImage.AtachDoc[cnt].LocalFolderPath = this.configurationDetaild[0]["LocalFolderPath"];
            this.itemToEditImage.AtachDoc[cnt].ClientDetails = this.configurationDetaild[0]["SFTPHost"] + "$" + this.configurationDetaild[0]["SFTPUserName"] + "$" + this.configurationDetaild[0]["SFTPPwd"] + "$" + this.configurationDetaild[0]["SFTPPort"];

            if (this.itemToEditImage.AtachDoc[cnt].FileName == "" && this.itemToEditImage.AtachDoc[cnt].UploadedName != "") {
              result = "Please enter file name.";
              this.toasterService.warning(result);
              break;
            } else {
              result = "";
            }
          }
        }

        if (result == "" && AddedNewFile) {
          formData.append('Data', JSON.stringify(this.itemToEditImage.AtachDoc));
          this.isInProgress = true;

          this.bookingloginService.UploadFileToCloud(formData).subscribe(data => {
            if (data != null && data.length > 0) {
              var result = data;
              this.isInProgress = false;
              if (result == "OK") {
                this.toasterService.success("Record Save Successfully!!");
                this.myFiles = [];
                this.GetSelectedPatientDetails(this.GuestQuetionaridetails[0]['PatientID']);
                // if (this.OpIpFlag) {
                //   this.router.navigate(['/opd/visit-mark']);
                // } else {
                //   this.router.navigate(["/ipd/admission"]);
                // }
              } else if (result == "blank") {
                this.toasterService.warning("Please set the path to upload file.");
              } else if (result == "SFTP connection error") {
                this.toasterService.error("Can't connect to server to upload file.");
              } else {
                this.toasterService.error("Something went wrong");
              }
            }
          });
        }
      } else {
        this.toasterService.error('File upload path is not set.');
      }
    } else {
      this.GetRefreshToken();
      this.UploadFile();
    }
  }


  dataURLtoFile(dataUrl: string, fileName: string): File {
    let arr = dataUrl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], fileName, { type: "image/png" }); // Ensure PNG format
  }

  OpenCameraPopUp() {
    this.ShowCamera = false;
  }

  goHome() {
    // Navigate again programmatically
    this.router.navigateByUrl('/session/home').then(() => {
      // Then hide the route from the URL
      history.replaceState({}, '', '/');
    });
  }

  Loginotp: string[] = new Array(4).fill('');

  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

  onInput(event: any, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.trim();
    this.Loginotp[index] = value; // Assign the digit properly
    setTimeout(() => {
      const nextInput = this.otpInputs.toArray()[index + 1];
      if (nextInput) {
        nextInput.nativeElement.value = ''
        nextInput.nativeElement.focus();
      }
    });
    // Auto-focus to the next field
  }

  onKeyDown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      this.Loginotp[index] = '';
      setTimeout(() => {
        if (index > 0) {
          this.otpInputs.toArray()[index - 1].nativeElement.focus();
        }
      });

    }
  }

  onInputR(event: any, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.trim();
    this.otp[index] = value; // Assign the digit properly
    setTimeout(() => {
      const nextInput = this.otpInputs.toArray()[index + 1];
      if (nextInput) {
        nextInput.nativeElement.value = ''
        nextInput.nativeElement.focus();
      }
    });
    // Auto-focus to the next field
  }

  onKeyDownR(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      this.otp[index] = '';
      setTimeout(() => {
        if (index > 0) {
          this.otpInputs.toArray()[index - 1].nativeElement.focus();
        }
      });

    }
  }
}

// This class is used to validate Aadhaar number using VerhoeffAlgorithm
class VerhoeffAlgorithm {
  // Multiplication Table (D)
  private static d: number[][] = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
    [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
    [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
    [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
    [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
    [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
    [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
    [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
    [9, 8, 7, 6, 5, 4, 3, 2, 1, 0],
  ];

  // Permutation Table (P)
  private static p: number[][] = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
    [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
    [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
    [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
    [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
    [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
    [7, 0, 4, 6, 9, 1, 3, 2, 5, 8],
  ];

  // Inverse Table
  private static inv: number[] = [0, 4, 3, 2, 1, 5, 6, 7, 8, 9];

  /**
   * Validates an Aadhaar number using Verhoeff Algorithm.
   * @param num - The Aadhaar number to validate.
   * @returns true if valid, false otherwise.
   */
  public static validateVerhoeff(num: string): boolean {
    let c = 0;
    const myArray = this.stringToReversedIntArray(num);

    for (let i = 0; i < myArray.length; i++) {
      c = this.d[c][this.p[i % 8][myArray[i]]];
    }
    return c === 0;
  }

  /**
   * Converts a string into a reversed integer array.
   * @param num - The string to convert.
   * @returns A reversed integer array.
   */
  private static stringToReversedIntArray(num: string): number[] {
    const myArray: number[] = num.split('').map((digit) => parseInt(digit, 10));
    return this.reverse(myArray);
  }

  /**
   * Reverses an array of integers.
   * @param myArray - The array to reverse.
   * @returns The reversed array.
   */
  private static reverse(myArray: number[]): number[] {
    return myArray.reverse();
  }
}
